import Navigation from "./Navigation.jsx";
import Header from "./Header.jsx";
import {ToastContainer} from "react-toastify";
import {Suspense, useEffect, useState} from "react";
import ApiRequester from "./ApiRequester.jsx";
import Button from "./component-assets/Button.jsx";
import {
    convertSecto12Hour,
    isBannerPresent,
    formCheck,
    sortFunc,
    checkAll,
    showModal,
    formSuccess, formFail, handleSubmitActions, swapModal, searchFunc
} from "../libs.jsx";
import CampusDropDown from "./component-assets/CampusDropDown.jsx";
import TableBody from "./component-assets/TableBody.jsx";
import TableHeaders from "./component-assets/TableHeaders.jsx";
import DayTimeRangeSlider from "./component-assets/DayTimeRangeSlider.jsx";
import MinTimeRangeSlider from "./component-assets/MinTimeRangeSlider.jsx";
import { getSession } from "../services/session";

const Careflow = (props) => {

    let dData, agHeaderData, rgHeaderData, dHeaderData, ugHeaderData, utHeaderData, ueHeaderData;
    if (getSession() != null) {
        dData = getSession();
    }

    agHeaderData = [
        {label: "Group", key: "area_group_name", align: "left"},
        {label: "Description", key: "area_group_description", align: "left"},
    ];

    rgHeaderData = [
        {label: "Group", key: "resident_group_name", align: "left"},
        {label: "Description", key: "resident_description", align: "left"},
    ];

    ugHeaderData = [
        {label: "Group", key: "group_name", align: "left"},
        {label: "Pager #", key: "capcode", align: "left"}
    ];

    utHeaderData = [
        {label: "Username", key: "username", align: "left"},
        {label: "Display", key: "display_name", align: "left"},
        {label: "Phone #", key: "phone", align: "left"}
    ];

    ueHeaderData = [
        {label: "Username", key: "username", align: "left"},
        {label: "Display", key: "display_name", align: "left"},
        {label: "Email Addr", key: "email", align: "left"}
    ]

    dHeaderData = [
        {label: "Name", key: "device_name", align: "left",
            link: {enabled: true, type: " ", linkto: "/profiles/inovonics", linkkey: "device_id",
                    inmodal: true, modalKey: "cancelBtn-device"}},
        {label: "Description", key: "descriptions", align: "left"},
        {label: "TX ID", key: "manufacture_uuid", align: "center"},
        {label: "Connected To", key: "entity_name", align: "center",
            link: {enabled: true, type: "conditional", inmodal: true, modalKey: "cancelBtn-device", conditionKey: "is_area_device",
                condition: {"1": {linkto: "/profiles/area", linkkey: "area_id"},
                            "0": {linkto: "/profiles/resident", linkkey: "resident_id"}}}}
    ];

    const mobileOn = dData?.campusData[dData?.acnt.toString()]?.app_active;
    const textOn = dData?.campusData[dData?.acnt.toString()]?.text_messaging_active;
    const pagerOn = dData?.campusData[dData?.acnt.toString()]?.pager_active;
    const voiceOn = dData?.campusData[dData?.acnt.toString()]?.voice_active;
    const emailOn = dData?.campusData[dData?.acnt.toString()]?.email_active;
    const offsiteOn = dData?.campusData[dData?.acnt.toString()]?.offsite_active;
    const escMin = 0;
    const escMax = dData?.campusData[dData?.acnt.toString()]?.alert_ttl ? dData?.campusData[dData?.acnt.toString()]?.alert_ttl : 3600;

    const [read, setRead] = useState(true);
    const [tabItem, setTabItem] = useState("init");
    const [campusId, setCampusId] = useState(dData.acnt);
    const [pageLoaded, setPageLoaded] = useState(false);
    const [careDataLoaded, setCareDataLoaded] = useState(false);
    const [originData, setOriginData] = useState([]);
    const [activeData, setActiveData] = useState([]);
    const [rActiveData, setRActiveData] = useState([]);
    const [dActiveData, setDActiveData] = useState([]);
    const [aActiveData, setAActiveData] = useState([]);
    const [eActiveData, setEActiveData] = useState([]);
    const [storedCType, setStoredCType] = useState(0);
    const [storedIndex, setStoredIndex] = useState(0);
    const [storedEscIndex, setStoredEscIndex] = useState(0);
    const [storedFlowIndex, setStoredFlowIndex] = useState(0);
    const [count, setCount] = useState(0);
    const [expandedEscalations, setExpandedEscalations] = useState({});
    const [startTime, setStartTime] = useState(0);
    const [endTime, setEndTime] = useState(86400);
    const [escStartTime, setEscStartTime] = useState(0);
    const [escEndTime, setEscEndTime] = useState(3600);
    const [showChecked, setShowChecked] = useState(false);
    // Other Data Variables
    const [eventCatData, setEventCatData] = useState([]);
    const [eventCatOptions, setEventCatOptions] = useState([]);
    const [eventCatId, setEventCatId] = useState(0);
    const [eventTypeData, setEventTypeData] = useState([]);
    const [eventTypeOptions, setEventTypeOptions] = useState([]);
    const [outputOp, setOutputOp] = useState("");
    const [careName, setCareName] = useState("");
    const [flowName, setFlowName] = useState("");
    const [escName, setEscName] = useState("");
    // Variables to handle user group entity selector
    const [userGroupData, setUserGroupData] = useState([]);
    const [userGroupLoaded, setUserGroupLoaded] = useState(false);
    const [userGroupSearch, setUserGroupSearch] = useState("");
    const [userGroupMobileRows, setUserGroupMobileRows] = useState([]);
    const [userGroupPagerRows, setUserGroupPagerRows] = useState([]);
    const [userGroupMobileIdList, setUserGroupMobileIdList] = useState([]);
    const [userGroupPagerIdList, setUserGroupPagerIdList] = useState([]);
    const [userGroupDataCnt, setUserGroupDataCnt] = useState(0);
    const [userGroupDataCnt2, setUserGroupDataCnt2] = useState(0);
    const [userGroupSorter, setUserGroupSorter] = useState({
        sortColumn: "group_name",
        sortOrder: "asc"
    });
    // Variables to handle user entity selector
    const [userData, setUserData] = useState([]);
    const [userLoaded, setUserLoaded] = useState(false);
    const [userSearch, setUserSearch] = useState("");
    const [userTextRows, setUserTextRows] = useState([]);
    const [userEmailRows, setUserEmailRows] = useState([]);
    const [userVoiceRows, setUserVoiceRows] = useState([]);
    const [userTextIdList, setUserTextIdList] = useState([]);
    const [userEmailIdList, setUserEmailIdList] = useState([]);
    const [userVoiceIdList, setUserVoiceIdList] = useState([]);
    const [userDataCnt, setUserDataCnt] = useState(0);
    const [userDataCnt2, setUserDataCnt2] = useState(0);
    const [userDataCnt3, setUserDataCnt3] = useState(0);
    const [userSorter, setUserSorter] = useState({
        sortColumn: "display_name",
        sortOrder: "asc"
    });
    // Variables to handle area group entity selector
    const [areaGroupData, setAreaGroupData] = useState([]);
    const [areaGroupLoaded, setAreaGroupLoaded] = useState(false);
    const [areaGroupIdList, setAreaGroupIdList] = useState([]);
    const [oldAreaGroupIdList, setOldAreaGroupIdList] = useState([]);
    const [areaGroupDataCnt, setAreaGroupDataCnt] = useState(0);
    const [areaGroupTableRows, setAreaGroupTableRows] = useState([]);
    const [areaGroupSearch, setAreaGroupSearch] = useState("");
    const [areaGroupSorter, setAreaGroupSorter] = useState({
        sortColumn: "area_group_name",
        sortOrder: "asc"
    });
    // Variables to handle resident group entity selector
    const [resGroupData, setResGroupData] = useState([]);
    const [resGroupLoaded, setResGroupLoaded] = useState(false);
    const [resGroupIdList, setResGroupIdList] = useState([]);
    const [oldResGroupIdList, setOldResGroupIdList] = useState([]);
    const [resGroupDataCnt, setResGroupDataCnt] = useState(0);
    const [resGroupTableRows, setResGroupTableRows] = useState([]);
    const [resGroupSearch, setResGroupSearch] = useState("");
    const [resGroupSorter, setResGroupSorter] = useState({
        sortColumn: "area_group_name",
        sortOrder: "asc"
    });
    // Variable to handle device entity selector
    const [devData, setDevData] = useState([]);
    const [devLoaded, setDevLoaded] = useState(false);
    const [devIdList, setDevIdList] = useState([]);
    const [oldDevIdList, setOldDevIdList] = useState([]);
    const [devDataCnt, setDevDataCnt] = useState(0);
    const [devTableRows, setDevTableRows] = useState([]);
    const [devSearch, setDevSearch] = useState("");
    const [devSorter, setDevSorter] = useState({
        sortColumn: "description",
        sortOrder: "asc"
    });

    // Helper function to toggle escalation expansion
    const toggleEscalation = (careflowId, escalationId) => {
        const key = `${careflowId}-${escalationId}`;
        setExpandedEscalations(prev => ({
            ...prev,
            [key]: !prev[key]
        }));
    };

    // Helper function to check for overlapping escalation periods
    const hasOverlappingEscalations = (careflowId, escalationId, periodStart, periodEnd) => {
        let currentCareflow;
        
        // Find the current careflow based on type
        if (tabItem === "default") {
            currentCareflow = activeData.find(c => c.careflow_id === careflowId);
        } else if (tabItem === "area") {
            currentCareflow = aActiveData.find(c => c.careflow_id === careflowId);
        } else if (tabItem === "resident") {
            currentCareflow = rActiveData.find(c => c.careflow_id === careflowId);
        } else if (tabItem === "device") {
            currentCareflow = dActiveData.find(c => c.careflow_id === careflowId);
        } else if (tabItem === "event") {
            currentCareflow = eActiveData.find(c => c.careflow_id === careflowId);
        }
        
        if (!currentCareflow || !currentCareflow.escalations) {
            return false;
        }
        
        // Check for overlaps with other escalations in the same careflow
        for (let escalation of currentCareflow.escalations) {
            if (escalation.escalation_id === escalationId) {
                continue; // Skip the current escalation
            }
            
            // Check if periods overlap
            if (!(periodEnd <= escalation.period_start || periodStart >= escalation.period_end)) {
                return true;
            }
        }
        
        return false;
    };

    // Helper function to check if escalation periods cover the full 0-3600 range
    const hasIncompletePeriodCoverage = (escalations) => {
        if (!escalations || escalations.length === 0) {
            return true; // No escalations means incomplete coverage
        }
        
        // Sort escalations by period_start
        const sortedEscalations = [...escalations].sort((a, b) => a.period_start - b.period_start);
        
        // Check if coverage starts at 0
        if (sortedEscalations[0].period_start > 0) {
            return true;
        }
        
        // Check if coverage ends at 3600
        if (sortedEscalations[sortedEscalations.length - 1].period_end < escMax) {
            return true;
        }
        
        // Check for gaps in coverage
        for (let i = 0; i < sortedEscalations.length - 1; i++) {
            if (sortedEscalations[i].period_end < sortedEscalations[i + 1].period_start) {
                return true; // Gap found
            }
        }
        
        return false;
    };

    // Helper function to check if workflows within a careflow cover the entire day
    const hasIncompleteDayCoverage = (workflows) => {
        if (!workflows || workflows.length === 0) {
            return true; // No workflows means incomplete coverage
        }
        
        // Sort workflows by window_start
        const sortedWorkflows = [...workflows].sort((a, b) => a.window_start - b.window_start);
        
        // Create a timeline array to track coverage
        const timeline = new Array(86400).fill(false);
        
        // Mark all covered time periods
        for (const workflow of sortedWorkflows) {
            const start = workflow.window_start;
            const end = workflow.window_end;
            
            if (end >= start) {
                // Normal workflow (doesn't wrap around midnight)
                for (let i = start; i < end; i++) {
                    timeline[i] = true;
                }
            } else {
                // Workflow wraps around midnight
                for (let i = start; i < 86400; i++) {
                    timeline[i] = true;
                }
                for (let i = 0; i < end; i++) {
                    timeline[i] = true;
                }
            }
        }
        
        // Check if there are any uncovered periods
        return timeline.includes(false);
    };

    useEffect(() => {
        let interval = null;
        interval = setInterval(() => {
             setCount(count => count - 1);
        }, 1000);
        if (count <= 0) {
            // Checkin items
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, "read-only": read,
                            procedure: "getcareflows", reqType: "stored"}).then(data => {
                setOriginData(data ? data : []);
                setCareDataLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "core_area_groups",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setAreaGroupData(data);
                setAreaGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_resident_groups",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setResGroupData(data);
                setResGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_event_categories",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setEventCatData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: campusId, Tbl: "att_event_types",
                                procedure: "fetchall", reqType: "direct", "read-only": true}).then(data => {
                setEventTypeData(data);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, "read-only": true,
                                procedure: "getusersandgroups", reqType: "stored"}).then(data => {
                setUserGroupData(data);
                setUserGroupLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", pKey: "campus_id", pVal: dData.acnt, Tbl: "core_user",
                                procedure: "fetchbyparameter", reqType: "direct", "read-only": true}).then(data => {
                setUserData(data);
                setUserLoaded(true);
            });
            ApiRequester({reqEndpoint: "myfetch", payload: {device_category_filter: "1,2,3,6,7,8,9,10,11,12,15,16,17",
                                device_filter: "", campus_id: campusId},
                                procedure: "sp_dev_getInovonicsDevices", reqType: "stored", "read-only": true}).then(data => {
                setDevData(data);
                setDevLoaded(true);
            });
            setRead(true);
            setCount(600);
        }
        return () => clearInterval(interval);
    }, [count, campusId]);

    useEffect(() => {
        if (![careDataLoaded].includes(false)){
            setPageLoaded(true);
            setTabItem("default");
        }
    }, [careDataLoaded, userGroupLoaded, areaGroupLoaded, resGroupLoaded, devLoaded, userLoaded]);

    useEffect(() => {
        if (careDataLoaded && originData){
            setActiveData(originData.filter(item => item.careflow_type_id === 1));
            setAActiveData(originData.filter(item => item.careflow_type_id === 5));
            setRActiveData(originData.filter(item => item.careflow_type_id === 4));
            setDActiveData(originData.filter(item => item.careflow_type_id === 3));
            setEActiveData(originData.filter(item => item.careflow_type_id === 6));
        }
    }, [originData, careDataLoaded]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["area_group_name", "area_group_description"];
        tmpData = searchFunc(areaGroupSearch, areaGroupData, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return areaGroupIdList.includes(item.area_group_id.toString())});
        }
        setAreaGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, areaGroupSorter.sortColumn, areaGroupSorter.sortOrder));
        setAreaGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                     actionAppearance={() => {}} tableHeaders={agHeaderData} checkboxId={"uCheckAreaGroup"}
                                     parentComponent={"Careflow"} dData={dData} checkboxlist={areaGroupIdList}
                                     modal={false} editModal={() => {}} unk={"xag-"}
                                     setCheckboxId={(value) => {setAreaGroupIdList(value)}} checkidkey={"area_group_id"} />);
    }, [areaGroupData, areaGroupIdList, areaGroupSorter, areaGroupSearch, showChecked]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["resident_group_name", "resident_description"];
        tmpData = searchFunc(resGroupSearch, resGroupData, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return resGroupIdList.includes(item.resident_group_id.toString())})
        }
        setResGroupDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, resGroupSorter.sortColumn, resGroupSorter.sortOrder));
        setResGroupTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                        actionAppearance={() => {}} tableHeaders={rgHeaderData} checkboxId={"uCheckResGroup"}
                                        parentComponent={"Careflow"} dData={dData} checkboxlist={resGroupIdList}
                                        modal={false} editModal={() => {}} unk={"x2-"}
                                        setCheckboxId={(value) => {setResGroupIdList(value)}} checkidkey={"resident_group_id"} />);
    }, [resGroupData, resGroupIdList, resGroupSorter, resGroupSearch, showChecked]);

    useEffect(() => {
        let tmpData, searchKeys;

        searchKeys = ["device_name", "descriptions", "manufacture_uuid", "device_category", "entity_name"];
        tmpData = searchFunc(devSearch, devData, searchKeys);
        if (showChecked){
            tmpData = tmpData.filter((item) => {return devIdList.includes(item.device_id.toString())});
        }
        setDevDataCnt(tmpData.length);
        tmpData.sort((a, b) => sortFunc(a, b, devSorter.sortColumn, devSorter.sortOrder));
        setDevTableRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={dHeaderData} checkboxId={"uCheckHeadDev"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={devIdList}
                                   modal={false} editModal={() => {}} unk={"xd-"}
                                   setCheckboxId={(value) => {setDevIdList(value)}} checkidkey={"device_id"} />);
    }, [devData, devIdList, devSorter, devSearch, showChecked]);

    useEffect(() => {
        let tmpData, tmpData2, searchKeys;

        searchKeys = ["group_name", "capcode"];
        tmpData = searchFunc(userGroupSearch, userGroupData, searchKeys);
        tmpData2 = tmpData
        if (showChecked){
            tmpData = tmpData.filter((item) => {return userGroupMobileIdList.includes(item.group_id.toString())});
            tmpData2 = tmpData2.filter((item) => {return userGroupPagerIdList.includes(item.group_id.toString())});
        }
        setUserGroupDataCnt(tmpData.length);
        setUserGroupDataCnt2(tmpData2.length);
        tmpData.sort((a, b) => sortFunc(a, b, userGroupSorter.sortColumn, userGroupSorter.sortOrder));
        setUserGroupMobileRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={ugHeaderData} checkboxId={"uCheckUGMobile"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={userGroupMobileIdList}
                                   modal={false} editModal={() => {}} unk={"xugm-"}
                                   setCheckboxId={(value) => {setUserGroupMobileIdList(value)}} checkidkey={"group_id"} />);
        setUserGroupPagerRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={ugHeaderData} checkboxId={"uCheckUGPager"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={userGroupPagerIdList}
                                   modal={false} editModal={() => {}} unk={"xugp-"}
                                   setCheckboxId={(value) => {setUserGroupPagerIdList(value)}} checkidkey={"group_id"} />);
    }, [userGroupData, userGroupMobileIdList, userGroupPagerIdList, userGroupSorter, userGroupSearch, showChecked]);

    useEffect(() => {
        let tmpData, tmpData2, tmpData3, searchKeys;

        searchKeys = ["username", "display_name", "phone", "email"];
        tmpData = searchFunc(userSearch, userData, searchKeys);
        tmpData2 = tmpData
        tmpData3 = tmpData
        if (showChecked){
            tmpData = tmpData.filter((item) => {return userTextIdList.includes(item.user_id.toString())});
            tmpData2 = tmpData2.filter((item) => {return userEmailIdList.includes(item.user_id.toString())});
            tmpData3 = tmpData3.filter((item) => {return userVoiceIdList.includes(item.user_id.toString())});
        }
        setUserDataCnt(tmpData.length);
        setUserDataCnt2(tmpData2.length);
        setUserDataCnt3(tmpData3.length);
        tmpData.sort((a, b) => sortFunc(a, b, userSorter.sortColumn, userSorter.sortOrder));
        setUserTextRows(<TableBody start={0} end={tmpData.length} tableData={tmpData} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={utHeaderData} checkboxId={"uCheckUserText"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={userTextIdList}
                                   modal={false} editModal={() => {}} unk={"xutxt-"}
                                   setCheckboxId={(value) => {setUserTextIdList(value)}} checkidkey={"user_id"} />);
        setUserEmailRows(<TableBody start={0} end={tmpData2.length} tableData={tmpData2} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={ueHeaderData} checkboxId={"uCheckUserEmail"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={userEmailIdList}
                                   modal={false} editModal={() => {}} unk={"xuem-"}
                                   setCheckboxId={(value) => {setUserEmailIdList(value)}} checkidkey={"user_id"} />);
        setUserVoiceRows(<TableBody start={0} end={tmpData3.length} tableData={tmpData3} checkbox={true} writeAccess={true}
                                   actionAppearance={() => {}} tableHeaders={utHeaderData} checkboxId={"uCheckUserVoice"}
                                   parentComponent={"Careflow"} dData={dData} checkboxlist={userVoiceIdList}
                                   modal={false} editModal={() => {}} unk={"xuvc-"}
                                   setCheckboxId={(value) => {setUserVoiceIdList(value)}} checkidkey={"user_id"} />);
    }, [userData, userTextIdList, userEmailIdList, userVoiceIdList, userSorter, userSearch, showChecked]);

    useEffect(() => {
        let tmp = [];
        if (eventCatData?.length > 0){
            eventCatData.sort((a, b) => sortFunc(a, b, "event_category_name", "asc"));
            for (let i=0; i < eventCatData.length; i++){
                if (eventCatData[i]?.event_category_id !== 1){
                    tmp.push(
                        <option key={`escalation-cat-option${i}`} value={eventCatData[i]?.event_category_id}>
                            {eventCatData[i]?.event_category_name}
                        </option>
                    );
                }
            }
            setEventCatOptions(tmp);
        }
    }, [eventCatData]);

    useEffect(() => {
        let tmp = [];
        if (eventTypeData?.length > 0){
            eventTypeData.sort((a, b) => sortFunc(a, b, "event_type_name", "asc"));
            for (let i=0; i < eventTypeData.length; i++){
                if (eventTypeData[i].event_category_id === eventCatId){
                    tmp.push(
                        <option key={`event-type-option${i}`} value={eventTypeData[i]?.event_type_id}>
                            {eventTypeData[i]?.event_type_name}
                        </option>
                    );
                }
            }
            setEventTypeOptions(tmp);
        }
    }, [eventTypeData, eventCatId]);

    function addCareModal(){
        document.getElementById("careflow-name").value = "";
        document.getElementById("careflow-desc").value = "";
        setAreaGroupSearch("");
        setDevSearch("");
        setResGroupSearch("");
        setUserSearch("");
        setUserGroupSearch("");
        setShowChecked(false);
        if (tabItem === "device"){
            setStoredCType(3);
            setDevIdList([]);
            setDevSearch("");
            document.getElementById("uCheckHeadDev").checked = false;
            document.getElementById("event-type").required = false;
            document.getElementById("event-category").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.remove("d-none");
        }else if (tabItem === "resident"){
            setStoredCType(4);
            setResGroupIdList([]);
            setResGroupSearch("");
            document.getElementById("uCheckHeadRG").checked = false;
            document.getElementById("event-type").required = false;
            document.getElementById("event-category").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.remove("d-none");
        }else if (tabItem === "area"){
            setStoredCType(5);
            setAreaGroupIdList([]);
            setAreaGroupSearch([]);
            document.getElementById("uCheckHeadAG").checked = false;
            document.getElementById("event-type").required = false;
            document.getElementById("event-category").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.remove("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
        }else if (tabItem === "event"){
            setStoredCType(6);
            document.getElementById("event-type").required = true;
            document.getElementById("event-type").value = 0;
            document.getElementById("event-category").required = true;
            document.getElementById("event-category").value = 0;
            document.getElementById("careflow-event-selector").classList.remove("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
        }else{
            setStoredCType(1);
            document.getElementById("event-type").required = false;
            document.getElementById("event-category").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
        }
        setOutputOp("Add");
        formCheck("careForm", "careSubmit");
        showModal("caremodal");
    }

    function editCareModal(index, cType){
        let tmp = [], cName;
        setStoredIndex(index);
        setStoredCType(cType);
        setUserSearch("");
        setUserGroupSearch("");
        if (cType === 6){
            cName = eActiveData[index].careflow_name;
            document.getElementById("careflow-desc").value = eActiveData[index].careflow_description;
            setEventCatId(eActiveData[index].event_category_id);
            document.getElementById("event-category").value = eActiveData[index].event_category_id;
            document.getElementById("event-type").value = eActiveData[index].event_type_id;
            document.getElementById("event-category").required = true;
            document.getElementById("event-type").required = true;
            document.getElementById("careflow-event-selector").classList.remove("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
        }else if (cType === 5){
            cName = aActiveData[index].careflow_name;
            document.getElementById("careflow-name").value = aActiveData[index].careflow_name;
            document.getElementById("careflow-desc").value = aActiveData[index].careflow_description;
            if (aActiveData[index]?.entities){
                for (let i=0; i < aActiveData[index]?.entities?.length; i++){
                    tmp.push(aActiveData[index].entities[i]?.reference_id.toString());
                }
            }
            setAreaGroupIdList(tmp);
            setOldAreaGroupIdList(tmp);
            document.getElementById("uCheckHeadAG").checked = tmp.length === areaGroupData?.length;
            setAreaGroupSearch("");
            setResGroupIdList([]);
            setDevIdList([]);
            document.getElementById("event-category").required = false;
            document.getElementById("event-type").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.remove("d-none");
        }else if (cType === 4){
            cName = rActiveData[index].careflow_name;
            document.getElementById("careflow-name").value = rActiveData[index].careflow_name;
            document.getElementById("careflow-desc").value = rActiveData[index].careflow_description;
            if (rActiveData[index]?.entities){
                for (let i=0; i < rActiveData[index]?.entities?.length; i++){
                    tmp.push(rActiveData[index].entities[i]?.reference_id.toString());
                }
            }
            setResGroupIdList(tmp);
            setOldResGroupIdList(tmp);
            document.getElementById("uCheckHeadRG").checked = tmp.length === resGroupData?.length;
            setResGroupSearch("");
            setAreaGroupIdList([]);
            setDevIdList([]);
            document.getElementById("event-category").required = false;
            document.getElementById("event-type").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.remove("d-none");
        }else if (cType === 3){
            cName = dActiveData[index].careflow_name;
            document.getElementById("careflow-name").value = dActiveData[index].careflow_name;
            document.getElementById("careflow-desc").value = dActiveData[index].careflow_description;
            if (dActiveData[index]?.entities){
                for (let i=0; i < dActiveData[index]?.entities?.length; i++){
                    tmp.push(dActiveData[index].entities[i]?.reference_id.toString());
                }
            }
            setDevIdList(tmp);
            setOldDevIdList(tmp);
            document.getElementById("uCheckHeadDev").checked = tmp.length === devData?.length;
            setDevSearch("");
            setResGroupIdList([]);
            setAreaGroupIdList([]);
            document.getElementById("event-category").required = false;
            document.getElementById("event-type").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.remove("d-none");
        }else{
            cName = activeData[index].careflow_name;
            document.getElementById("careflow-name").value = activeData[index].careflow_name;
            document.getElementById("careflow-desc").value = activeData[index].careflow_description;
            document.getElementById("event-category").required = false;
            document.getElementById("event-type").required = false;
            document.getElementById("careflow-event-selector").classList.add("d-none");
            document.getElementById("area-group-selector").classList.add("d-none");
            document.getElementById("res-group-selector").classList.add("d-none");
            document.getElementById("dev-selector").classList.add("d-none");
        }
        document.getElementById("careflow-name").value = cName;
        setCareName(cName);
        setOutputOp("Edit");
        formCheck("careForm", "careSubmit");
        showModal("caremodal");
    }

    function addFlowModal(cIndex, cType){
        setStoredIndex(cIndex);
        setStoredCType(cType);
        document.getElementById("workflow-name").value = "";
        document.getElementById("workflow-mute").checked = false;
        if (cType === 1){
            document.getElementById("mute-container").classList.add("d-none");
        }else{
            document.getElementById("mute-container").classList.remove("d-none");
        }
        setStartTime(0);
        setEndTime(86400);
        setOutputOp("Add");
        showModal("flowmodal");
    }

    function editFlowModal(cIndex, wIndex, cType){
        let name;
        setStoredIndex(cIndex);
        setStoredFlowIndex(wIndex);
        setStoredCType(cType);
        if (cType === 6){
            name = eActiveData[cIndex].workflows[wIndex].workflow_name;
            document.getElementById("mute-container").classList.remove("d-none");
            document.getElementById("workflow-mute").checked = eActiveData[cIndex].workflows[wIndex].is_mute;
            setStartTime(eActiveData[cIndex].workflows[wIndex].window_start);
            setEndTime(eActiveData[cIndex].workflows[wIndex].window_end);
        }else if (cType === 5){
            name = aActiveData[cIndex].workflows[wIndex].workflow_name;
            document.getElementById("mute-container").classList.remove("d-none");
            document.getElementById("workflow-mute").checked = aActiveData[cIndex].workflows[wIndex].is_mute;
            setStartTime(aActiveData[cIndex].workflows[wIndex].window_start);
            setEndTime(aActiveData[cIndex].workflows[wIndex].window_end);
        }else if (cType === 4){
            name = rActiveData[cIndex].workflows[wIndex].workflow_name;
            document.getElementById("mute-container").classList.remove("d-none");
            document.getElementById("workflow-mute").checked = rActiveData[cIndex].workflows[wIndex].is_mute;
            setStartTime(rActiveData[cIndex].workflows[wIndex].window_start);
            setEndTime(rActiveData[cIndex].workflows[wIndex].window_end);
        }else if (cType === 3){
            name = dActiveData[cIndex].workflows[wIndex].workflow_name;
            document.getElementById("mute-container").classList.remove("d-none");
            document.getElementById("workflow-mute").checked = dActiveData[cIndex].workflows[wIndex].is_mute;
            setStartTime(dActiveData[cIndex].workflows[wIndex].window_start);
            setEndTime(dActiveData[cIndex].workflows[wIndex].window_end);
        }else{
            name = activeData[cIndex].workflows[wIndex].workflow_name;
            document.getElementById("mute-container").classList.add("d-none");
            document.getElementById("workflow-mute").checked = false;
            setStartTime(activeData[cIndex].workflows[wIndex].window_start);
            setEndTime(activeData[cIndex].workflows[wIndex].window_end);
        }
        document.getElementById("workflow-name").value = name;
        setFlowName(name);
        setOutputOp("Edit");
        showModal("flowmodal");
    }

    function addEscModal(cIndex, wIndex, cType){
        let m, p, t, e, v, o;
        setStoredCType(cType);
        setStoredIndex(cIndex);
        setStoredFlowIndex(wIndex);
        setShowChecked(false);
        document.getElementById("esc-name").value = "";
        m = document.getElementById("esc-mobile");
        p = document.getElementById("esc-pager");
        t = document.getElementById("esc-text");
        e = document.getElementById("esc-email");
        v = document.getElementById("esc-voice");
        o = document.getElementById("esc-offsite");
        if (m){
            m.checked = true;
            m.click();
        }
        if (p){
            p.checked = true;
            p.click();
        }
        if (t){
            t.checked = true
            t.click();
        }
        if (e){
            e.checked = true
            e.click();
        }
        if (v){
            v.checked = true;
            v.click();
        }
        if (o){
            o.checked = true;
            o.click();
        }
        setEscStartTime(escMin);
        setEscEndTime(escMax);
        setUserSearch("");
        setUserGroupSearch("");
        setUserGroupMobileIdList([]);
        setUserGroupPagerIdList([]);
        setUserTextIdList([]);
        setUserEmailIdList([]);
        setUserVoiceIdList([]);
        setOutputOp("Add");
        formCheck("escForm", "escSubmit");
        showModal("escmodal");
    }

    function editEscModal(cIndex, wIndex, eIndex, cType){
        let outputs = [], m, r, tmp, escName;
        setStoredCType(cType);
        setStoredIndex(cIndex);
        setStoredFlowIndex(wIndex);
        setStoredEscIndex(eIndex);
        setShowChecked(false);
        setUserSearch("");
        setUserGroupSearch("");
        if (cType === 6){
            escName = eActiveData[cIndex].workflows[wIndex].escalations[eIndex].escalation_name;
            setEscStartTime(eActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_start);
            setEscEndTime(eActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_end);
            outputs = eActiveData[cIndex].workflows[wIndex].escalations[eIndex].outputs;
        }else if (cType === 5){
            escName = aActiveData[cIndex].workflows[wIndex].escalations[eIndex].escalation_name;
            setEscStartTime(aActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_start);
            setEscEndTime(aActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_end);
            outputs = aActiveData[cIndex].workflows[wIndex].escalations[eIndex].outputs;
        }else if (cType === 4){
            escName = rActiveData[cIndex].workflows[wIndex].escalations[eIndex].escalation_name;
            setEscStartTime(rActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_start);
            setEscEndTime(rActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_end);
            outputs = rActiveData[cIndex].workflows[wIndex].escalations[eIndex].outputs;
        }else if (cType === 3){
            escName = dActiveData[cIndex].workflows[wIndex].escalations[eIndex].escalation_name;
            setEscStartTime(dActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_start);
            setEscEndTime(dActiveData[cIndex].workflows[wIndex].escalations[eIndex].period_end);
            outputs = dActiveData[cIndex].workflows[wIndex].escalations[eIndex].outputs;
        }else{
            escName = activeData[cIndex].workflows[wIndex].escalations[eIndex].escalation_name;
            setEscStartTime(activeData[cIndex].workflows[wIndex].escalations[eIndex].period_start);
            setEscEndTime(activeData[cIndex].workflows[wIndex].escalations[eIndex].period_end);
            outputs = activeData[cIndex].workflows[wIndex].escalations[eIndex].outputs;
        }
        document.getElementById("esc-name").value = escName;
        setEscName(escName);

        for (let i=0; i < outputs.length; i++){
            tmp = [];
            m = null;
            r = null;
            if (outputs[i].output_type_id === 3){
                m = document.getElementById("esc-mobile");
                r = document.getElementById("esc-mobile-repeat");
            }else if (outputs[i].output_type_id === 4){
                m = document.getElementById("esc-text");
                r = document.getElementById("esc-text-repeat");
            }else if (outputs[i].output_type_id === 5){
                m = document.getElementById("esc-voice");
                r = document.getElementById("esc-voice-repeat");
            }else if (outputs[i].output_type_id === 6){
                m = document.getElementById("esc-email");
                r = document.getElementById("esc-email-repeat");
            }else if (outputs[i].output_type_id === 7){
                m = document.getElementById("esc-pager");
                r = document.getElementById("esc-pager-repeat");
            }else if (outputs[i].output_type_id === 9){
                m = document.getElementById("esc-offsite");
            }
            if (m){
                m.checked = !outputs[i].enabled;
                m.click();
            }
            if (outputs[i].enabled){
                if (r){
                    r.value = outputs[i].repeat_interval/60;
                }
                for (let i2=0; i2 < outputs[i].entities.length; i2++){
                    tmp.push(outputs[i].entities[i2].reference.toString());
                }
            }
            if (outputs[i].output_type_id === 3){
                setUserGroupMobileIdList(tmp);
                document.getElementById("uCheckHeadUGMobile").checked = tmp.length === userGroupData.length;
            }else if (outputs[i].output_type_id === 4){
                setUserTextIdList(tmp)
                document.getElementById("uCheckHeadUserText").checked = tmp.length === userData.length;
            }else if (outputs[i].output_type_id === 5){
                setUserVoiceIdList(tmp)
                document.getElementById("uCheckHeadVoice").checked = tmp.length === userData.length;
            }else if (outputs[i].output_type_id === 6){
                setUserEmailIdList(tmp)
                document.getElementById("uCheckHeadUserEmail").checked = tmp.length === userData.length;
            }else if (outputs[i].output_type_id === 7){
                setUserGroupPagerIdList(tmp)
                document.getElementById("uCheckHeadUGPager").checked = tmp.length === userGroupData.length;
            }
        }
        setOutputOp("Edit");
        formCheck("escForm", "escSubmit");
        showModal("escmodal");
    }

    function addCareflowSubmit(){
        let payload, newEntities = [], eCatId = 1, eTypeId = 1;
        handleSubmitActions("careSubmit", "loadCareSubmit");

        if (storedCType === 6){
            eCatId = parseInt(document.getElementById("event-category").value);
            eTypeId = parseInt(document.getElementById("event-type").value);
        }else if (storedCType === 5){
            newEntities = areaGroupIdList;
        }else if (storedCType === 4){
            newEntities = resGroupIdList;
        }else{
            newEntities = devIdList;
        }
        payload = [{
            careflow_name: document.getElementById("careflow-name").value,
            careflow_description: document.getElementById("careflow-desc").value,
            careflow_type_id: storedCType, attached_entities: newEntities, event_category_id: eCatId,
            event_type_id: eTypeId, window_frequency_id: 1, campus_id: campusId
        }]
        ApiRequester({reqEndpoint: "mytransaction", TransType: "careflow_v2_add", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Careflow added", "careSubmit", "loadCareSubmit", "cancelCareBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Add failed.", "careSubmit", "loadCareSubmit");
            }
        });
    }

    function addWorkflowSubmit(){
        let payload, isMute, cId;
        handleSubmitActions("flowSubmit", "loadFlowSubmit");
        if (storedCType === 6){
            cId = eActiveData[storedIndex].careflow_id;
            isMute = document.getElementById("workflow-mute").checked;
        }else if (storedCType === 5){
            cId = aActiveData[storedIndex].careflow_id;
            isMute = document.getElementById("workflow-mute").checked;
        }else if (storedCType === 4){
            cId = rActiveData[storedIndex].careflow_id;
            isMute = document.getElementById("workflow-mute").checked;
        }else if (storedCType === 3){
            cId = dActiveData[storedIndex].careflow_id;
            isMute = document.getElementById("workflow-mute").checked;
        }else{
            cId = activeData[storedIndex].careflow_id;
            isMute = false;
        }
        payload = [{
            workflow_name: document.getElementById("workflow-name").value,
            is_mute: isMute ? 1 : 0, window_start: startTime, window_end: endTime,
            campus_id: campusId, careflow_id: cId
        }]
        ApiRequester({reqEndpoint: "mytransaction", TransType: "workflow_v2_add", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Workflow added", "flowSubmit", "loadFlowSubmit", "cancelFlowBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Add failed.", "flowSubmit", "loadFlowSubmit");
            }
        });
    }

    function addEscalationSubmit(){
        let payload, wId, mChk, mRp = 0, tChk, tRp = 0, vChk, vRp = 0, eChk,
            eRp = 0, pChk, pRp = 0, oChk;
        handleSubmitActions("escSubmit", "loadEscSubmit");
        if (storedCType === 3){
            wId = dActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
        }else if (storedCType === 4){
            wId = rActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
        }else if (storedCType === 5){
            wId = aActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
        }else if (storedCType === 6){
            wId = eActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
        }else{
            wId = activeData[storedIndex].workflows[storedFlowIndex].workflow_id;
        }
        mChk = document.getElementById("esc-mobile")?.checked;
        if (mChk){
            mRp = document.getElementById("esc-mobile-repeat")?.value ? parseInt(document.getElementById("esc-mobile-repeat").value)*60 : 0;
        }
        tChk = document.getElementById("esc-text")?.checked;
        if (tChk){
            tRp = document.getElementById("esc-text-repeat")?.value ? parseInt(document.getElementById("esc-text-repeat").value)*60 : 0;
        }
        vChk = document.getElementById("esc-voice")?.checked;
        if (vChk){
            vRp = document.getElementById("esc-voice-repeat")?.value ? parseInt(document.getElementById("esc-voice-repeat").value)*60 : 0;
        }
        eChk = document.getElementById("esc-email")?.checked;
        if (eChk){
            eRp = document.getElementById("esc-email-repeat")?.value ? parseInt(document.getElementById("esc-email-repeat").value)*60 : 0;
        }
        pChk = document.getElementById("esc-pager")?.checked;
        if (pChk){
            pRp = document.getElementById("esc-pager-repeat")?.value ? parseInt(document.getElementById("esc-pager-repeat").value)*60 : 0;
        }
        oChk = document.getElementById("esc-offsite")?.checked;
        payload = [{
            workflow_id: wId, period_start: escStartTime, period_end: escEndTime, campus_id: campusId,
            escalation_name: document.getElementById("esc-name").value,
            outputs: [
                {output_type_id: 3, enabled: mChk ? mChk : 0, repeat_interval: mRp, entities: mChk ? userGroupMobileIdList : []},
                {output_type_id: 4, enabled: tChk ? tChk : 0, repeat_interval: tRp, entities: tChk ? userTextIdList : []},
                {output_type_id: 5, enabled: vChk ? vChk : 0, repeat_interval: vRp, entities: vChk ? userVoiceIdList : []},
                {output_type_id: 6, enabled: eChk ? eChk : 0, repeat_interval: eRp, entities: eChk ? userEmailIdList : []},
                {output_type_id: 7, enabled: pChk ? pChk : 0, repeat_interval: pRp, entities: pChk ? userGroupPagerIdList: []},
                {output_type_id: 9, enabled: oChk ? oChk : 0, repeat_interval: 0, entities: []}
            ]
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "escalation_v2_add", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Escalation added", "escSubmit", "loadEscSubmit", "cancelEscBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Add failed.", "escSubmit", "loadEscSubmit");
            }
        });
    }

    function editCareflowSubmit(){
        let payload, oldPayload, cId, oldName, oldDesc, oldEntities, newEntities,
            oldCatId, oldTypeId, cCatId = 1, cTypeId = 1, oldFreqId;
        handleSubmitActions("careSubmit", "loadCareSubmit");
        if (storedCType === 6){
            cId = eActiveData[storedIndex].careflow_id;
            oldName = eActiveData[storedIndex].careflow_name;
            oldDesc = eActiveData[storedIndex].careflow_description;
            oldCatId = eActiveData[storedIndex].event_category_id;
            oldTypeId = eActiveData[storedIndex].event_type_id;
            oldFreqId = eActiveData[storedIndex].window_frequency_id;
            cCatId = parseInt(document.getElementById("event-category").value);
            cTypeId = parseInt(document.getElementById("event-type").value);
            newEntities = [];
            oldEntities = [];
        }else if (storedCType === 5){
            cId = aActiveData[storedIndex].careflow_id;
            oldName = aActiveData[storedIndex].careflow_name;
            oldDesc = aActiveData[storedIndex].careflow_description;
            oldCatId = aActiveData[storedIndex].event_category_id;
            oldTypeId = aActiveData[storedIndex].event_type_id;
            oldFreqId = aActiveData[storedIndex].window_frequency_id;
            newEntities = areaGroupIdList;
            oldEntities = oldAreaGroupIdList;
        }else if (storedCType === 4){
            cId = rActiveData[storedIndex].careflow_id;
            oldName = rActiveData[storedIndex].careflow_name;
            oldDesc = rActiveData[storedIndex].careflow_description;
            oldCatId = rActiveData[storedIndex].event_category_id;
            oldTypeId = rActiveData[storedIndex].event_type_id;
            oldFreqId = rActiveData[storedIndex].window_frequency_id;
            newEntities = resGroupIdList;
            oldEntities = oldResGroupIdList;
        }else if (storedCType === 3){
            cId = dActiveData[storedIndex].careflow_id;
            oldName = dActiveData[storedIndex].careflow_name;
            oldDesc = dActiveData[storedIndex].careflow_description;
            oldCatId = dActiveData[storedIndex].event_category_id;
            oldTypeId = dActiveData[storedIndex].event_type_id;
            oldFreqId = dActiveData[storedIndex].window_frequency_id;
            newEntities = [];
            oldEntities = [];
        }else{
            cId = activeData[storedIndex].careflow_id;
            oldName = activeData[storedIndex].careflow_name;
            oldDesc = activeData[storedIndex].careflow_description;
            oldCatId = activeData[storedIndex].event_category_id;
            oldTypeId = activeData[storedIndex].event_type_id;
            oldFreqId = activeData[storedIndex].window_frequency_id;
            newEntities = [];
            oldEntities = [];
        }
        payload = [{
            careflow_id: cId, careflow_type_id: storedCType, event_category_id: cCatId, event_type_id: cTypeId,
            careflow_name: document.getElementById("careflow-name").value,
            careflow_description: document.getElementById("careflow-desc").value, window_frequency_id: oldFreqId,
            campus_id: campusId, attached_entities: newEntities
        }];
        oldPayload = [{
            careflow_id: cId, careflow_name: oldName, careflow_description: oldDesc,
            attached_entities: oldEntities, careflow_type_id: storedCType,
            event_category_id: oldCatId, event_type_id: oldTypeId, window_frequency_id: oldFreqId
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "careflow_v2_edit", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Careflow updated", "careSubmit", "loadCareSubmit", "cancelCareBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Update failed.", "careSubmit", "loadCareSubmit");
            }
        });
    }

    function editWorkflowSubmit(){
        let payload, oldPayload, oldName, oldStart, oldEnd, oldMute, wId;
        handleSubmitActions("flowSubmit", "loadFlowSubmit");
        if (storedCType === 6){
            wId = eActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            oldName = eActiveData[storedIndex].workflows[storedFlowIndex].workflow_name;
            oldStart = eActiveData[storedIndex].workflows[storedFlowIndex].window_start;
            oldEnd = eActiveData[storedIndex].workflows[storedFlowIndex].window_end;
            oldMute = eActiveData[storedIndex].workflows[storedFlowIndex].is_mute;
        }else if (storedCType === 5){
            wId = aActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            oldName = aActiveData[storedIndex].workflows[storedFlowIndex].workflow_name;
            oldStart = aActiveData[storedIndex].workflows[storedFlowIndex].window_start;
            oldEnd = aActiveData[storedIndex].workflows[storedFlowIndex].window_end;
            oldMute = aActiveData[storedIndex].workflows[storedFlowIndex].is_mute;
        }else if (storedCType === 4){
            wId = rActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            oldName = rActiveData[storedIndex].workflows[storedFlowIndex].workflow_name;
            oldStart = rActiveData[storedIndex].workflows[storedFlowIndex].window_start;
            oldEnd = rActiveData[storedIndex].workflows[storedFlowIndex].window_end;
            oldMute = rActiveData[storedIndex].workflows[storedFlowIndex].is_mute;
        }else if (storedCType === 3){
            wId = dActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            oldName = dActiveData[storedIndex].workflows[storedFlowIndex].workflow_name;
            oldStart = dActiveData[storedIndex].workflows[storedFlowIndex].window_start;
            oldEnd = dActiveData[storedIndex].workflows[storedFlowIndex].window_end;
            oldMute = dActiveData[storedIndex].workflows[storedFlowIndex].is_mute;
        }else{
            wId = activeData[storedIndex].workflows[storedFlowIndex].workflow_id;
            oldName = activeData[storedIndex].workflows[storedFlowIndex].workflow_name;
            oldStart = activeData[storedIndex].workflows[storedFlowIndex].window_start;
            oldEnd = activeData[storedIndex].workflows[storedFlowIndex].window_end;
            oldMute = activeData[storedIndex].workflows[storedFlowIndex].is_mute;
        }
        payload = [{
            workflow_id: wId,
            workflow_name: document.getElementById("workflow-name").value,
            window_start: startTime, window_end: endTime, campus_id: campusId,
            is_mute: document.getElementById("workflow-mute").checked
        }];
        oldPayload = [{
            workflow_id: wId, workflow_name: oldName, window_start: oldStart, window_end: oldEnd, is_mute: oldMute
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "workflow_v2_edit", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Workflow edited", "flowSubmit", "loadFlowSubmit", "cancelFlowBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Edit failed.", "flowSubmit", "loadFlowSubmit");
            }
        });
    }

    function editEscalationSubmit(){
        let payload, oldPayload, eId, oldName, oldStart, oldEnd, outputs, mChk, mRp = 0, tChk, tRp = 0, vChk,
            vRp = 0, eChk, eRp = 0, pChk, pRp = 0, oChk;
        handleSubmitActions("escSubmit", "loadEscSubmit");
        if (storedCType === 6){
            eId = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            oldName = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_name;
            oldStart = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_start;
            oldEnd = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_end;
            outputs = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs;
        }else if (storedCType === 5){
            eId = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            oldName = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_name;
            oldStart = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_start;
            oldEnd = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_end;
            outputs = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs;
        }else if (storedCType === 4){
            eId = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            oldName = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_name;
            oldStart = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_start;
            oldEnd = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_end;
            outputs = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs;
        }else if (storedCType === 3){
            eId = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            oldName = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_name;
            oldStart = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_start;
            oldEnd = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_end;
            outputs = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs;
        }else{
            eId = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            oldName = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_name;
            oldStart = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_start;
            oldEnd = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].period_end;
            outputs = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs;
        }
        mChk = document.getElementById("esc-mobile")?.checked;
        if (mChk){
            mRp = document.getElementById("esc-mobile-repeat")?.value ? parseInt(document.getElementById("esc-mobile-repeat").value)*60 : 0;
        }
        tChk = document.getElementById("esc-text")?.checked;
        if (tChk){
            tRp = document.getElementById("esc-text-repeat")?.value ? parseInt(document.getElementById("esc-text-repeat").value)*60 : 0;
        }
        vChk = document.getElementById("esc-voice")?.checked;
        if (vChk){
            vRp = document.getElementById("esc-voice-repeat")?.value ? parseInt(document.getElementById("esc-voice-repeat").value)*60 : 0;
        }
        eChk = document.getElementById("esc-email")?.checked;
        if (eChk){
            eRp = document.getElementById("esc-email-repeat")?.value ? parseInt(document.getElementById("esc-email-repeat").value)*60 : 0;
        }
        pChk = document.getElementById("esc-pager")?.checked;
        if (pChk){
            pRp = document.getElementById("esc-pager-repeat")?.value ? parseInt(document.getElementById("esc-pager-repeat").value)*60 : 0;
        }
        oChk = document.getElementById("esc-offsite")?.checked;
        payload = [{
            escalation_id: eId, period_start: escStartTime, period_end: escEndTime, campus_id: campusId,
            escalation_name: document.getElementById("esc-name").value,
            outputs: [
                {output_id: outputs.filter(item => item.output_type_id === 3)[0].output_id,
                    output_type_id: 3, enabled: mChk ? mChk : 0, repeat_interval: mRp, entities: mChk ? userGroupMobileIdList : []},
                {output_id: outputs.filter(item => item.output_type_id === 4)[0].output_id,
                    output_type_id: 4, enabled: tChk ? tChk : 0, repeat_interval: tRp, entities: tChk ? userTextIdList: []},
                {output_id: outputs.filter(item => item.output_type_id === 5)[0].output_id,
                    output_type_id: 5, enabled: vChk ? vChk : 0, repeat_interval: vRp, entities: vChk ? userVoiceIdList: []},
                {output_id: outputs.filter(item => item.output_type_id === 6)[0].output_id,
                    output_type_id: 6, enabled: eChk ? eChk : 0, repeat_interval: eRp, entities: eChk ? userEmailIdList : []},
                {output_id: outputs.filter(item => item.output_type_id === 7)[0].output_id,
                    output_type_id: 7, enabled: pChk ? pChk : 0, repeat_interval: pRp, entities: pChk ? userGroupPagerIdList : []},
                {output_id: outputs.filter(item => item.output_type_id === 9)[0].output_id,
                    output_type_id: 9, enabled: oChk ? oChk : 0, repeat_interval: 0, entities: []}
            ]
        }];
        oldPayload = [{
            escalation_name: oldName, period_start: oldStart, period_end: oldEnd
        }];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "escalation_v2_edit", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: oldPayload,
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Escalation added", "escSubmit", "loadEscSubmit", "cancelEscBtn");
                setRead(false);
                setCount(0);
            } else {
                formFail("Add failed.", "escSubmit", "loadEscSubmit");
            }
        });
    }

    function deleteCareflowSubmit(){
        let payload, cId, workflows = [], escalations = [], flowIds = [], escIds = [], outputIds = [], outputs;
        handleSubmitActions("careDeleteSubmit", "loadCareDeleteSubmit");
        if (storedCType === 6){
            cId = eActiveData[storedIndex].careflow_id;
            workflows = eActiveData[storedIndex]?.workflows ? dActiveData[storedIndex].workflows : [];
        }else if (storedCType === 5){
            cId = aActiveData[storedIndex].careflow_id;
            workflows = aActiveData[storedIndex]?.workflows ? aActiveData[storedIndex].workflows : [];
        }else if (storedCType === 4){
            cId = rActiveData[storedIndex].careflow_id;
            workflows = rActiveData[storedIndex]?.workflows ? rActiveData[storedIndex].workflows : [];
        }else if (storedCType === 3){
            cId = dActiveData[storedIndex].careflow_id;
            workflows = dActiveData[storedIndex]?.workflows ? dActiveData[storedIndex].workflows : [];
        }else{
            cId = activeData[storedIndex].careflow_id;
            workflows = activeData[storedIndex]?.workflows ? activeData[storedIndex].workflows : [];
        }
        for (let i=0; i < workflows.length; i++){
            flowIds.push(workflows[i].workflow_id);
            escalations = workflows[i]?.escalations ? workflows[i].escalations : [];
            for (let i2=0; i2 < escalations.length; i2++){
                escIds.push(escalations[i2].escalation_id);
                outputs = escalations[i2]?.outputs ? escalations[i2].outputs : [];
                for (let i3=0; i3 < outputs.length; i3++){
                    outputIds.push(outputs[i2].output_id);
                }
            }
        }
        payload = [{careflow_id: cId, campus_id: campusId, workflows: flowIds, escalations: escIds,
                    outputs: outputIds}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "careflow_v2_delete", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Careflow removed", "careDeleteSubmit", "loadCareDeleteSubmit", "careDeleteSubmitClose");
                setRead(false);
                setCount(0);
            } else {
                formFail("Removal failed.", "careDeleteSubmit", "loadCareDeleteSubmit");
            }
        });
    }

    function deleteWorkflowSubmit(){
        let payload, wId, escalations = [], escIds = [], outputIds = [], outputs;
        handleSubmitActions("flowDeleteSubmit", "loadFlowDeleteSubmit");
        if (storedCType === 3){
            wId = dActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            escalations = dActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations ? dActiveData[storedIndex].workflows[storedFlowIndex].escalations : [];
        }else if (storedCType === 4){
            wId = rActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            escalations = rActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations ? rActiveData[storedIndex].workflows[storedFlowIndex].escalations : [];
        }else if (storedCType === 5){
            wId = aActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            escalations = aActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations ? aActiveData[storedIndex].workflows[storedFlowIndex].escalations : [];
        }else if (storedCType === 6){
            wId = eActiveData[storedIndex].workflows[storedFlowIndex].workflow_id;
            escalations = eActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations ? eActiveData[storedIndex].workflows[storedFlowIndex].escalations : [];
        }else{
            wId = activeData[storedIndex].workflows[storedFlowIndex].workflow_id;
            escalations = activeData[storedIndex]?.workflows[storedFlowIndex]?.escalations ? activeData[storedIndex].workflows[storedFlowIndex].escalations : [];
        }
        for (let i=0; i < escalations.length; i++){
            escIds.push(escalations[i].escalation_id);
            outputs = escalations[i]?.outputs ? escalations[i].outputs : [];
            for (let i2=0; i2 < outputs.length; i2++){
                outputIds.push(outputs[i2].output_id);
            }
        }
        payload = [{workflow_id: wId, campus_id: campusId, escalations: escIds, outputs: outputIds}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "workflow_v2_delete", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Careflow removed", "flowDeleteSubmit", "loadFlowDeleteSubmit", "flowDeleteSubmitClose");
                setRead(false);
                setCount(0);
            } else {
                formFail("Removal failed.", "flowDeleteSubmit", "loadFlowDeleteSubmit");
            }
        });
    }

    function deleteEscalationSubmit(){
        let payload, eId, outputs, outIds = [];
        handleSubmitActions("escDeleteSubmit", "loadEscDeleteSubmit");
        if (storedCType === 3){
            eId = dActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            outputs = dActiveData[storedIndex]?.escalations[storedEscIndex]?.outputs ? dActiveData[storedIndex].escalations[storedEscIndex].outputs : [];
        }else if (storedCType === 4){
            eId = rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            outputs = rActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations[storedEscIndex]?.outputs ? rActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs : [];
        }else if (storedCType === 5){
            eId = aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            outputs = aActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations[storedEscIndex]?.outputs ? aActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs : [];
        }else if (storedCType === 6){
            eId = eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            outputs = eActiveData[storedIndex]?.workflows[storedFlowIndex]?.escalations[storedEscIndex]?.outputs ? eActiveData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs : [];
        }else{
            eId = activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].escalation_id;
            outputs = activeData[storedIndex]?.workflows[storedFlowIndex]?.escalations[storedEscIndex]?.outputs ? activeData[storedIndex].workflows[storedFlowIndex].escalations[storedEscIndex].outputs : [];
        }
        for (let i=0; i < outputs.length; i++){
            outIds.push(outputs[i].output_id);
        }
        payload = [{escalation_id: eId, campus_id: campusId, outputs: outIds}];
        ApiRequester({reqEndpoint: "mytransaction", TransType: "escalation_v2_delete", Payload: payload,
                            CampusId: campusId, User: dData.user, OldPayload: [],
                            ClientId: dData.sessionId}).then(data => {
            if (data[0]) {
                formSuccess("Escalation removed", "escDeleteSubmit", "loadEscDeleteSubmit", "escDeleteSubmitClose");
                setRead(false);
                setCount(0);
            } else {
                formFail("Removal failed.", "escDeleteSubmit", "loadEscDeleteSubmit");
            }
        });
    }

    function show_output(output){
        if (output.output_type_id === 3 && mobileOn){
            return true;
        }else if (output.output_type_id === 4 && textOn){
            return true;
        }else if (output.output_type_id === 5 && voiceOn){
            return true;
        }else if (output.output_type_id === 6 && emailOn){
            return true;
        }else if (output.output_type_id === 7 && pagerOn){
            return true;
        }else if (output.output_type_id === 9 && offsiteOn){
            return true;
        }else{
            return false;
        }
    }

    const headerContent = (
        <div className={"d-flex justify-content-between"}>
            <div>
                {tabItem !== "default" || (activeData && activeData.length === 0) ? <Button text={"New Careflow"} type={"button"} class={"btn btn-primary ms-2 mt-1"}
                        icon={true} iconClass={"fe fe-plus me-2"} onClick={() => addCareModal()} /> : <></>}
            </div>
            <CampusDropDown campusId={campusId} setCampusId={(item) => setCampusId(item)}
                            setCount={(item) => setCount(item)} pageAction={(e) => {
                                if (dData?.campusData[campusId.toString()]?.careflow_v2 !== dData?.campusData[e.target.value]?.careflow_v2){
                                    window.location.href = "/settings/wellness";
                                }else if (dData?.campusData[campusId.toString()]?.is_cloud !== dData?.campusData[e.target.value]?.is_cloud){
                                    window.location.reload();
                                }else{
                                    setCareDataLoaded(false);
                                    setPageLoaded(false);
                                }
            }} />
        </div>
    )

    const areaGroupTableHeader = <TableHeaders checkbox={true} headerData={agHeaderData} checkboxHeaderId={"uCheckHeadAG"}
                                               checkAll={() => checkAll(0, areaGroupDataCnt ? areaGroupDataCnt : 0, areaGroupIdList, setAreaGroupIdList, "uCheckHeadAG", "uCheckAreaGroup")}
                                               writeAccess={true} sortOrder={areaGroupSorter.sortOrder} sortColumn={areaGroupSorter.sortColumn}
                                               sorter={areaGroupSorter} setSorter={setAreaGroupSorter} actionAppearance={() => {}} />
    const resGroupTableHeader = <TableHeaders checkbox={true} headerData={rgHeaderData} checkboxHeaderId={"uCheckHeadRG"}
                                               checkAll={() => checkAll(0, resGroupDataCnt ? resGroupDataCnt : 0, resGroupIdList, setResGroupIdList, "uCheckHeadRG", "uCheckResGroup")}
                                               writeAccess={true} sortOrder={resGroupSorter.sortOrder} sortColumn={resGroupSorter.sortColumn}
                                               sorter={resGroupSorter} setSorter={setResGroupSorter} actionAppearance={() => {}} />
    const devTableHeader = <TableHeaders checkbox={true} headerData={dHeaderData} checkboxHeaderId={"uCheckHeadDev"}
                                         checkAll={() => checkAll(0, devDataCnt ? devDataCnt : 0, devIdList, setDevIdList, "uCheckHeadDev", "uCheckDev")}
                                         writeAccess={true} sortOrder={devSorter.sortOrder} sortColumn={devSorter.sortColumn}
                                         sorter={devSorter} setSorter={setDevSorter} actionAppearance={() => {}} />
    const uGroupMobileTableHeader = <TableHeaders checkbox={true} headerData={ugHeaderData} checkboxHeaderId={"uCheckHeadUGMobile"}
                                         checkAll={() => checkAll(0, userGroupDataCnt ? userGroupDataCnt : 0, userGroupMobileIdList, setUserGroupMobileIdList, "uCheckHeadUGMobile", "uCheckUGMobile")}
                                         writeAccess={true} sortOrder={userGroupSorter.sortOrder} sortColumn={userGroupSorter.sortColumn}
                                         sorter={userGroupSorter} setSorter={setUserGroupSorter} actionAppearance={() => {}} />
    const uGroupPagerTableHeader = <TableHeaders checkbox={true} headerData={ugHeaderData} checkboxHeaderId={"uCheckHeadUGPager"}
                                         checkAll={() => checkAll(0, userGroupDataCnt2 ? userGroupDataCnt2 : 0, userGroupPagerIdList, setUserGroupPagerIdList, "uCheckHeadUGPager", "uCheckUGPager")}
                                         writeAccess={true} sortOrder={userGroupSorter.sortOrder} sortColumn={userGroupSorter.sortColumn}
                                         sorter={userGroupSorter} setSorter={setUserGroupSorter} actionAppearance={() => {}} />
    const userTextTableHeader = <TableHeaders checkbox={true} headerData={utHeaderData} checkboxHeaderId={"uCheckHeadUserText"}
                                         checkAll={() => checkAll(0, userDataCnt ? userDataCnt : 0, userTextIdList, setUserTextIdList, "uCheckHeadUserText", "uCheckUserText")}
                                         writeAccess={true} sortOrder={userSorter.sortOrder} sortColumn={userSorter.sortColumn}
                                         sorter={userSorter} setSorter={setUserSorter} actionAppearance={() => {}} />
    const userVoiceTableHeader = <TableHeaders checkbox={true} headerData={utHeaderData} checkboxHeaderId={"uCheckHeadVoice"}
                                         checkAll={() => checkAll(0, userDataCnt3 ? userDataCnt3 : 0, userVoiceIdList, setUserVoiceIdList, "uCheckHeadVoice", "uCheckUserVoice")}
                                         writeAccess={true} sortOrder={userSorter.sortOrder} sortColumn={userSorter.sortColumn}
                                         sorter={userSorter} setSorter={setUserSorter} actionAppearance={() => {}} />
    const userEmailTableHeader = <TableHeaders checkbox={true} headerData={ueHeaderData} checkboxHeaderId={"uCheckHeadUserEmail"}
                                         checkAll={() => checkAll(0, userDataCnt2 ? userDataCnt2 : 0, userEmailIdList, setUserEmailIdList, "uCheckHeadUserEmail", "uCheckUserEmail")}
                                         writeAccess={true} sortOrder={userSorter.sortOrder} sortColumn={userSorter.sortColumn}
                                         sorter={userSorter} setSorter={setUserSorter} actionAppearance={() => {}} />

    return (
        <>
            <Navigation/>
            <div className={"main-content"}>
                <Header preTitle={"Settings"} Title={"Careflow"} content={headerContent}/>
                <div className={"container-fluid"}>
                    <div className={`row align-items-center ${isBannerPresent() ? "sticky-table-headX" : "sticky-table-head"}`}
                         style={{backgroundColor: "var(--color-bg-primary)", zIndex: 2}}>
                        <div className={"col"}>
                            <ul className={"nav nav-tabs nav-overflow header-tabs"}>
                                <li key={"set-default"} className={"nav-item"}>
                                    <button type={"button"} className={tabItem === "default" ? "nav-link active" : "nav-link"}
                                            onClick={() => setTabItem("default")}>
                                        Default Careflow
                                        <span className={"position-relative translate-middle badge rounded-pill bg-info"}
                                              style={{left: "15px"}}>{activeData?.length > 0 ? activeData.length : ""}</span>
                                    </button>
                                </li>
                                {dData?.campusData[campusId]?.use_area_careflow
                                    ?   <li key={"set-area"} className={"nav-item"}>
                                            <button type={"button"} className={tabItem === "area" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setTabItem("area")}>
                                                Area Careflow
                                                <span className={"position-relative translate-middle badge rounded-pill bg-info"}
                                                      style={{left: "15px"}}>{aActiveData?.length > 0 ? aActiveData.length : ""}</span>
                                            </button>
                                        </li>
                                    :   <></>
                                }
                                {dData?.campusData[campusId]?.use_resident_careflow
                                    ?   <li key={"set-resident"} className={"nav-item"}>
                                            <button type={"button"} className={tabItem === "resident" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setTabItem("resident")}>
                                                Resident Careflow
                                                <span className={"position-relative translate-middle badge rounded-pill bg-info"}
                                                      style={{left: "15px"}}>{rActiveData?.length > 0 ? rActiveData.length : ""}</span>
                                            </button>
                                        </li>
                                    :   <></>
                                }
                                {dData?.campusData[campusId]?.use_device_careflow
                                    ?   <li key={"set-device"} className={"nav-item"}>
                                            <button type={"button"} className={tabItem === "device" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setTabItem("device")}>
                                                Device Careflow
                                                <span className={"position-relative translate-middle badge rounded-pill bg-info"}
                                                      style={{left: "15px"}}>{dActiveData?.length > 0 ? dActiveData.length : ""}</span>
                                            </button>
                                        </li>
                                    :   <></>
                                }
                                {dData?.campusData[campusId]?.use_event_careflow
                                    ?   <li key={"set-override"} className={"nav-item"}>
                                            <button type={"button"} className={tabItem === "event" ? "nav-link active" : "nav-link"}
                                                    onClick={() => setTabItem("event")}>
                                                Event Careflow
                                                <span className={"position-relative translate-middle badge rounded-pill bg-info"}
                                                      style={{left: "15px"}}>{eActiveData?.length > 0 ? eActiveData.length : ""}</span>
                                            </button>
                                        </li>
                                    :   <></>
                                }
                            </ul>
                        </div>
                    </div>
                    <div className={tabItem === "init" ? "d-block" : "d-none"}>
                        <span className={"spinner-border me-5"} role={"status"} aria-hidden={true}/>
                    </div>
                    <div className={tabItem === "default" ? "d-block" : "d-none"}>
                        <div style={{maxWidth: "1200px", minWidth: "600px"}}>
                             <div className={"alert alert-info border-0 text-muted"}
                                  style={{
                                     backgroundColor: "#f8f9fa",
                                     borderLeft: "4px solid #007bff",
                                     borderRadius: "8px",
                                     padding: "16px 20px",
                                     marginBottom: "24px",
                                     boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                 }}>
                                 <i className={"fe fe-info me-2 text-info"}></i>
                                 <strong className={"text-info"}>Default Careflow</strong> serves as the 5th and final default level of priority when no higher-priority Careflows takes precedence
                             </div>
                        </div>
                         {!activeData || activeData.length === 0
                             ?   <div className={"row"}>
                                     <div className={"col-12"}>
                                         <div className={"alert alert-danger border-0"} style={{
                                             backgroundColor: "#f8d7da",
                                             borderLeft: "4px solid #dc3545",
                                             borderRadius: "8px",
                                             padding: "20px",
                                             textAlign: "center",
                                             boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                         }}>
                                             <i className={"fe fe-alert-triangle fs-1 text-danger mb-3 d-block"}></i>
                                             <h4 className={"text-danger mb-0"}>No Default Careflow set up.</h4>
                                         </div>
                                     </div>
                                 </div>
                             :   <></>
                         }
                        {activeData.map((c, cIndex) => {
                            const hasWorkflow = c?.workflows?.length && c.workflows.length > 0;
                            const hasIncompleteDay = hasWorkflow && hasIncompleteDayCoverage(c.workflows);
                            return (
                                <>
                                    <div className={`card px-5 py-4 ${!hasWorkflow ? "border-danger" : hasIncompleteDay ? "border-warning" : ""}`} style={{maxWidth: "1200px", minWidth: "600px"}}>
                                        <div className={"row mb-4"}>
                                            <div className={"col-md-6"}>
                                                {!hasWorkflow
                                                    ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                            backgroundColor: "#f8d7da",
                                                            borderLeft: "4px solid #dc3545",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "var(--color-danger)"
                                                        }}>
                                                            <i className={"fe fe-info me-2"} style={{color: "var(--color-danger)"}}></i>
                                                            No workflows set up on careflow
                                                        </div>
                                                    : hasIncompleteDay
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "#f6c343"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            Workflows do not cover the entire day
                                                        </div>
                                                    :   <></>
                                                }
                                                <div>
                                                    <h3 className={"fs-3 mb-3 fw-bold"}>{c.careflow_name}
                                                        <Button id={`careflow-default-${cIndex}-edit-btn`} text={"Edit"}
                                                                class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                iconClass={"fe fe-edit me-2"}
                                                                onClick={() => {editCareModal(cIndex, c.careflow_type_id)}} />
                                                    </h3>
                                                    <h4>{c.careflow_description}</h4>
                                                </div>
                                            </div>
                                            <div className={"col-md-6"}>
                                                {c.entities && c.entities.length > 0 && (
                                                    <div className={"text-end"}>
                                                        <div className={"d-flex flex-wrap justify-content-end gap-1"}>
                                                            {c.entities.map((entity, index) => (
                                                                <span key={index} className={"badge bg-info"}
                                                                      title={"Attached area group"}>
                                                                    {entity.reference_name}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {c.workflows && c.workflows.length > 0 && (
                                            <>
                                                <div className={"px-2"}>
                                                    <div className={"mb-4"}>
                                                        <h5 className={"text-info fw-bold mb-3"} style={{borderBottom: "2px solid var(--color-border-light)", paddingBottom: "12px"}}>
                                                            <i className={"fe fe-clock me-2"}></i>
                                                            Workflows
                                                        </h5>
                                                    </div>
                                                    {c.workflows.map((w, wIndex) => {
                                                        const hasEscalations = w?.escalations && w.escalations.length > 0;
                                                        return (
                                                        <>
                                                            <div className={`border rounded ${(!hasEscalations || hasIncompletePeriodCoverage(w.escalations)) ? "border-danger" : "border-primary border-shine"} p-4 mt-3 mb-4`}
                                                                 style={{backgroundColor: "var(--color-bg-primary)", boxShadow: "var(--color-border-medium) 0px 0px 4px"}}>
                                                                <div className={"row"}>
                                                                    <div className={"col-md-6"}>
                                                                        {!hasEscalations
                                                                            ?   <div className={"alert alert-danger border-0 mb-3 mt-2"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    No escalation set up on workflow
                                                                                </div>
                                                                            : hasIncompletePeriodCoverage(w.escalations)
                                                                            ?   <div className={"alert alert-danger border-0 mb-3 mt-2"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    Escalation does not have full coverage
                                                                                </div>
                                                                            :   <></>
                                                                        }
                                                                        <h3 className={"fs-3 mb-3 fw-bold"}>
                                                                            {w.workflow_name}
                                                                            <Button id={`workflow-default-${cIndex}-edit-btn`} text={"Edit"}
                                                                                    class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                    iconClass={"fe fe-edit me-2"}
                                                                                    onClick={() => {editFlowModal(cIndex, wIndex, c.careflow_type_id)}} />
                                                                        </h3>
                                                                        <div>
                                                                            <h4 className={"text-muted mb-0"}>{convertSecto12Hour(w.window_start)} - {convertSecto12Hour(w.window_end)}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-md-6"}>
                                                                    </div>
                                                                </div>
                                                                <div className={"mt-0"}>
                                                                    {w.escalations && w.escalations.length > 0 && (
                                                                    <>
                                                                        <div className={"mt-4 mb-3"}>
                                                                            <h6 className={"text-info fw-bold mb-3"} style={{borderBottom: "1px solid var(--color-border)", paddingBottom: "8px"}}>
                                                                                <i className={"fe fe-activity me-2"}></i>
                                                                                Escalations
                                                                            </h6>
                                                                        </div>
                                                                        <div className={"mt-3"}>
                                                                            {w.escalations.map((escalation, eIndex) => {
                                                                                const hasOverlap = hasOverlappingEscalations(w.workflow_id, escalation.escalation_id, escalation.period_start, escalation.period_end);
                                                                                return (
                                                                                    <div key={escalation.escalation_id} className={`border bg-white rounded p-3 mb-2 ${hasOverlap ? 'border-warning' : ''}`}
                                                                                         style={{boxShadow: "var(--color-border-medium) 1px 1px 0"}}>
                                                                                        {hasOverlap && (
                                                                                            <h4 className={"text-warning"}>
                                                                                                <i className={"fe fe-info align-bottom fs-2 me-2 no-hover"}></i>
                                                                                                Escalation period overlaps with another escalation
                                                                                            </h4>
                                                                                        )}
                                                                                        <div className={"d-flex justify-content-between align-items-center"}>
                                                                                            <div>
                                                                                                <h3 className={"fs-4 fw-bold mb-1"}>{escalation.escalation_name}
                                                                                                    <Button id={`escalation-default-${cIndex}-edit-btn`} text={"Edit"}
                                                                                                            class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                                            iconClass={"fe fe-edit me-2"}
                                                                                                            onClick={() => {editEscModal(cIndex, wIndex, eIndex, c.careflow_type_id)}} />
                                                                                                </h3>
                                                                                                <small className={"text-muted"}>
                                                                                                    Period: {Math.floor(escalation.period_start / 60)} min - {Math.floor(escalation.period_end / 60)} min
                                                                                                </small>
                                                                                            </div>
                                                                                            <button className={"btn btn-sm btn-outline-primary"} style={{minWidth: "100px"}}
                                                                                                    onClick={() => toggleEscalation(w.workflow_id, escalation.escalation_id)}>
                                                                                                {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] ? "Hide Details" : "Show Details"}
                                                                                            </button>
                                                                                        </div>
                                                                                        {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] && (
                                                                                            <div className={"mt-3"}>
                                                                                                {escalation.outputs && escalation.outputs.length > 0 ? (
                                                                                                    <ul className={"list-unstyled"}>
                                                                                                        {escalation.outputs.map((output) => {
                                                                                                            const entWarning = output.enabled && (!output?.entities || output.entities.length === 0) && output.output_type_id !== 9;
                                                                                                            const showOutput = show_output(output)
                                                                                                            return (showOutput ?
                                                                                                                <li key={output.output_id} className={"mb-1"}>
                                                                                                                    <span className={`badge ${entWarning ? 'bg-warning' : output.enabled ? 'bg-success' : 'bg-secondary'} me-2`} style={{minWidth: "58px"}}>
                                                                                                                        {output.enabled ? 'Enabled' : 'Disabled'}
                                                                                                                    </span>
                                                                                                                    {output.output}
                                                                                                                    {output.entities && output.entities.length > 0
                                                                                                                        ? <small className={"text-muted ms-2 fw-bold"}>({output.entities.map(ref => ref.reference_display).join(', ')})</small>
                                                                                                                        : <></>
                                                                                                                    }
                                                                                                                    {output.enabled ? <small className={"text-muted ms-2"}>• {output.repeat_interval > 0 ? `Repeat every ${Math.floor(output.repeat_interval / 60)} min` : 'Sent once'}</small> : <></>}
                                                                                                                </li> : <></>

                                                                                                            )}
                                                                                                        )}
                                                                                                    </ul>
                                                                                                ) : (
                                                                                                    <p className={"text-muted"}>No outputs configured</p>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                    <div className={"d-flex justify-content-end"}>
                                                                        <Button text={"Escalation"} type={"button"}
                                                                                class={"btn btn-info  ms-2 mt-1"} icon={true}
                                                                                iconClass={"fe fe-plus me-2"}
                                                                                onClick={() => addEscModal(cIndex, wIndex, c.careflow_type_id)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        <div className={"d-flex justify-content-start"}>
                                            <Button text={"Workflow"} type={"button"}
                                                    class={"btn btn-primary ms-2 mt-1"} icon={true}
                                                    iconClass={"fe fe-plus me-2"}
                                                    onClick={() => addFlowModal(cIndex, c.careflow_type_id)} />
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className={tabItem === "area" ? "d-block" : "d-none"}>
                        <div style={{maxWidth: "1200px", minWidth: "600px"}}>
                             <div className={"alert alert-info border-0 text-muted"}
                                  style={{
                                     backgroundColor: "#f8f9fa",
                                     borderLeft: "4px solid #007bff",
                                     borderRadius: "8px",
                                     padding: "16px 20px",
                                     marginBottom: "24px",
                                     boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                 }}>
                                 <i className={"fe fe-info me-2 text-info"}></i>
                                 <strong className={"text-info"}>Area Careflow</strong> is the 4th level of priority in the priority hierarchy and will
                                    apply to any event associated with an area in any attached area group when no other higher-priority Careflow takes precedence.
                                    This supersedes all default careflows.
                             </div>
                        </div>
                        {!aActiveData || aActiveData.length === 0
                             ?   <div className={"row"}>
                                     <div className={"col-12"}>
                                         <div className={"alert alert-warning border-0"} style={{
                                             backgroundColor: "#fff3cd",
                                             borderLeft: "4px solid #ffc107",
                                             borderRadius: "8px",
                                             padding: "20px",
                                             textAlign: "center",
                                             boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                         }}>
                                             <i className={"fe fe-info fs-1 text-warning mb-3 d-block"}></i>
                                             <h4 className={"text-warning mb-0"}>No Area Careflows being utilized.</h4>
                                         </div>
                                     </div>
                                 </div>
                             :   <></>
                        }
                        {aActiveData.map((c, cIndex) => {
                            const hasEntity = c?.entities?.length && c.entities.length > 0;
                            const hasWorkflow = c?.workflows?.length && c.workflows.length > 0;
                            const hasIncompleteDay = hasWorkflow && hasIncompleteDayCoverage(c.workflows);
                            return (
                                <>
                                    <div className={`card px-5 py-4 ${!hasWorkflow ? "border-danger" : !hasEntity ? "border-warning" : hasIncompleteDay ? "border-warning" : ""}`} style={{maxWidth: "1200px", minWidth: "600px"}}>
                                        <div className={"row mb-4"}>
                                            <div className={"col-md-6"}>
                                                {!hasWorkflow
                                                    ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                            backgroundColor: "#f8d7da",
                                                            borderLeft: "4px solid #dc3545",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "var(--color-danger)"
                                                        }}>
                                                            <i className={"fe fe-info me-2"} style={{color: "var(--color-danger)"}}></i>
                                                            No workflows set up on careflow
                                                        </div>
                                                    : hasIncompleteDay
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "#f6c343"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            Workflows do not cover the entire day
                                                        </div>
                                                    :   <></>
                                                }
                                                {!hasEntity
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            No assigned area groups
                                                        </div>
                                                    :   <></>
                                                }
                                                <div>
                                                    <h3 className={"fs-3 mb-3 fw-bold"}>{c.careflow_name}
                                                        <Button id={`careflow-area-${cIndex}-edit-btn`} text={"Edit"}
                                                                class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                iconClass={"fe fe-edit me-2"}
                                                                onClick={() => {editCareModal(cIndex, c.careflow_type_id)}} />
                                                    </h3>
                                                    <h4>{c.careflow_description}</h4>
                                                </div>
                                            </div>
                                            <div className={"col-md-6"}>
                                                {c.entities && c.entities.length > 0 && (
                                                    <div className={"text-end"}>
                                                        <div className={"d-flex flex-wrap justify-content-end gap-1"}>
                                                            {c.entities.map((entity, index) => (
                                                                <span key={index} className={"badge bg-info"}
                                                                      title={"Attached area group"}>
                                                                    {entity.reference_name}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {c.workflows && c.workflows.length > 0 && (
                                            <>
                                                <div className={"px-2"}>
                                                    <div className={"mb-4"}>
                                                        <h5 className={"text-info fw-bold mb-3"} style={{borderBottom: "2px solid var(--color-border-light)", paddingBottom: "12px"}}>
                                                            <i className={"fe fe-clock me-2"}></i>
                                                            Workflows
                                                        </h5>
                                                    </div>
                                                    {c.workflows.map((w, wIndex) => {
                                                        const hasEscalations = w?.escalations && w.escalations.length > 0;
                                                        return (
                                                        <>
                                                            <div className={`border rounded ${(!hasEscalations || hasIncompletePeriodCoverage(w.escalations)) ? "border-danger" : "border-primary border-shine"} p-4 mt-3 mb-4`}
                                                                 style={{backgroundColor: "var(--color-bg-primary)", boxShadow: "var(--color-border-medium) 0px 0px 4px"}}>
                                                                {/*<div className={"border border-secondary mt-4 mb-3"}></div>*/}
                                                                <div className={"row"}>
                                                                    <div className={"col-md-6"}>
                                                                        {!hasEscalations
                                                                            ?   <div className={"alert alert-danger border-0 mb-3 mt-2"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    No escalation set up on workflow
                                                                                </div>
                                                                            : hasIncompletePeriodCoverage(w.escalations)
                                                                            ?   <div className={"alert alert-danger border-0 mb-3 mt-2"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    Escalation does not have full coverage
                                                                                </div>
                                                                            :   <></>
                                                                        }
                                                                        <h3 className={"fs-3 mb-3 fw-bold"}>
                                                                            {w.workflow_name}
                                                                            <Button id={`workflow-area-${cIndex}-edit-btn`} text={"Edit"}
                                                                                    class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                    iconClass={"fe fe-edit me-2"}
                                                                                    onClick={() => {editFlowModal(cIndex, wIndex, c.careflow_type_id)}} />
                                                                        </h3>
                                                                        <div>
                                                                            <h4 className={"text-muted mb-0"}>{convertSecto12Hour(w.window_start)} - {convertSecto12Hour(w.window_end)}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-md-6"}>
                                                                    </div>
                                                                </div>
                                                                <div className={"mt-0"}>
                                                                    {w.escalations && w.escalations.length > 0 && (
                                                                    <>
                                                                        <div className={"mt-4 mb-3"}>
                                                                            <h6 className={"text-info fw-bold mb-3"} style={{borderBottom: "1px solid var(--color-border)", paddingBottom: "8px"}}>
                                                                                <i className={"fe fe-activity me-2"}></i>
                                                                                Escalations
                                                                            </h6>
                                                                        </div>
                                                                        <div className={"mt-3"}>
                                                                            {w.escalations.map((escalation, eIndex) => {
                                                                                const hasOverlap = hasOverlappingEscalations(w.workflow_id, escalation.escalation_id, escalation.period_start, escalation.period_end);
                                                                                return (
                                                                                    <div key={escalation.escalation_id} className={`border bg-white rounded p-3 mb-2 ${hasOverlap ? 'border-warning' : ''}`}
                                                                                         style={{boxShadow: "var(--color-border-medium) 1px 1px 0"}}>
                                                                                        {hasOverlap && (
                                                                                            <div className={"alert alert-warning border-0 mb-3"} style={{
                                                                                                backgroundColor: "#fff3cd",
                                                                                                borderLeft: "4px solid #ffc107",
                                                                                                borderRadius: "6px",
                                                                                                padding: "12px 16px"
                                                                                            }}>
                                                                                                <i className={"fe fe-info me-2"}></i>
                                                                                                Escalation period overlaps with another escalation
                                                                                            </div>
                                                                                        )}
                                                                                        <div className={"d-flex justify-content-between align-items-center"}>
                                                                                            <div>
                                                                                                <h3 className={"fs-4 fw-bold mb-1"}>{escalation.escalation_name}
                                                                                                    <Button id={`escalation-area-${cIndex}-edit-btn`} text={"Edit"}
                                                                                                            class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                                            iconClass={"fe fe-edit me-2"}
                                                                                                            onClick={() => {editEscModal(cIndex, wIndex, eIndex, c.careflow_type_id)}} />
                                                                                                </h3>
                                                                                                <small className={"text-muted"}>
                                                                                                    Period: {Math.floor(escalation.period_start / 60)} min - {Math.floor(escalation.period_end / 60)} min
                                                                                                </small>
                                                                                            </div>
                                                                                            <button className={"btn btn-sm btn-outline-primary"} style={{minWidth: "100px"}}
                                                                                                    onClick={() => toggleEscalation(w.workflow_id, escalation.escalation_id)}>
                                                                                                {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] ? "Hide Details" : "Show Details"}
                                                                                            </button>
                                                                                        </div>
                                                                                        {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] && (
                                                                                            <div className={"mt-3"}>
                                                                                                {escalation.outputs && escalation.outputs.length > 0 ? (
                                                                                                    <ul className={"list-unstyled"}>
                                                                                                        {escalation.outputs.map((output) => {
                                                                                                            const entWarning = output.enabled && (!output?.entities || output.entities.length === 0) && output.output_type_id !== 9;
                                                                                                            const showOutput = show_output(output);
                                                                                                            return (showOutput ?
                                                                                                                <li key={output.output_id} className={"mb-1"}>
                                                                                                                    <span className={`badge ${entWarning ? 'bg-warning' : output.enabled ? 'bg-success' : 'bg-secondary'} me-2`} style={{minWidth: "58px"}}>
                                                                                                                        {output.enabled ? 'Enabled' : 'Disabled'}
                                                                                                                    </span>
                                                                                                                    {output.output}
                                                                                                                    {output.entities && output.entities.length > 0
                                                                                                                        ? <small className={"text-muted ms-2 fw-bold"}>({output.entities.map(ref => ref.reference_display).join(', ')})</small>
                                                                                                                        : <></>
                                                                                                                    }
                                                                                                                    {output.enabled ? <small className={"text-muted ms-2"}>• {output.repeat_interval > 0 ? `Repeat every ${Math.floor(output.repeat_interval / 60)} min` : 'Sent once'}</small> : <></>}
                                                                                                                </li> : <></>

                                                                                                            )}
                                                                                                        )}
                                                                                                    </ul>
                                                                                                ) : (
                                                                                                    <p className={"text-muted"}>No outputs configured</p>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                    <div className={"d-flex justify-content-end"}>
                                                                        <Button text={"Escalation"} type={"button"}
                                                                                class={"btn btn-info  ms-2 mt-1"} icon={true}
                                                                                iconClass={"fe fe-plus me-2"}
                                                                                onClick={() => addEscModal(cIndex, wIndex, c.careflow_type_id)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        <div className={"d-flex justify-content-start"}>
                                            <Button text={"Workflow"} type={"button"}
                                                    class={"btn btn-primary ms-2 mt-1"} icon={true}
                                                    iconClass={"fe fe-plus me-2"}
                                                    onClick={() => addFlowModal(cIndex, c.careflow_type_id)} />
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className={tabItem === "resident" ? "d-block" : "d-none"}>
                        <div style={{maxWidth: "1200px", minWidth: "600px"}}>
                             <div className={"alert alert-info border-0 text-muted"}
                                  style={{
                                     backgroundColor: "#f8f9fa",
                                     borderLeft: "4px solid #007bff",
                                     borderRadius: "8px",
                                     padding: "16px 20px",
                                     marginBottom: "24px",
                                     boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                 }}>
                                 <i className={"fe fe-info me-2 text-info"}></i>
                                 <strong className={"text-info"}>Resident Careflow</strong> holds the third-highest priority in the hierarchy.
                                 It applies to all events associated with a resident in any attached resident group, provided no higher-priority
                                 Careflow takes precedence. This Careflow supersedes all default and area Careflows
                             </div>
                        </div>
                        {!rActiveData || rActiveData.length === 0
                             ?   <div className={"row"}>
                                     <div className={"col-12"}>
                                         <div className={"alert alert-warning border-0"} style={{
                                             backgroundColor: "#fff3cd",
                                             borderLeft: "4px solid #ffc107",
                                             borderRadius: "8px",
                                             padding: "20px",
                                             textAlign: "center",
                                             boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                         }}>
                                             <i className={"fe fe-info fs-1 text-warning mb-3 d-block"}></i>
                                             <h4 className={"text-warning mb-0"}>No Resident Careflows being utilized.</h4>
                                         </div>
                                     </div>
                                 </div>
                             :   <></>
                        }
                        {rActiveData?.map((c, cIndex) => {
                            const hasEntity = c?.entities?.length && c.entities.length > 0;
                            const hasWorkflow = c?.workflows?.length && c.workflows.length > 0;
                            const hasIncompleteDay = hasWorkflow && hasIncompleteDayCoverage(c.workflows);
                            return (
                                <>
                                    <div className={`card px-5 py-4 ${!hasWorkflow ? "border-danger" : !hasEntity ? "border-warning" : hasIncompleteDay ? "border-warning" : ""}`} style={{maxWidth: "1200px", minWidth: "600px"}}>
                                        <div className={"row mb-4"}>
                                            <div className={"col-md-6"}>
                                                {!hasWorkflow
                                                    ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                            backgroundColor: "#f8d7da",
                                                            borderLeft: "4px solid #dc3545",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "var(--color-danger)"
                                                        }}>
                                                            <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                            No workflows set up on careflow
                                                        </div>
                                                    : hasIncompleteDay
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "#f6c343"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            Workflows do not cover the entire day
                                                        </div>
                                                    :   <></>
                                                }
                                                {!hasEntity
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            No assigned resident groups
                                                        </div>
                                                    :   <></>
                                                }
                                                <div>
                                                    <h3 className={"fs-3 mb-3 fw-bold"}>{c.careflow_name}
                                                        <Button id={`careflow-resident-${cIndex}-edit-btn`} text={"Edit"}
                                                                class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                iconClass={"fe fe-edit me-2"}
                                                                onClick={() => {editCareModal(cIndex, c.careflow_type_id)}} />
                                                    </h3>
                                                    <h4>{c.careflow_description}</h4>
                                                </div>
                                            </div>
                                            <div className={"col-md-6"}>
                                                {c.entities && c.entities.length > 0 && (
                                                    <div className={"text-end"}>
                                                        <div className={"d-flex flex-wrap justify-content-end gap-1"}>
                                                            {c.entities.map((entity, index) => (
                                                                <span key={index} className={"badge bg-info"}
                                                                      title={"Attached area group"}>
                                                                    {entity.reference_name}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {c.workflows && c.workflows.length > 0 && (
                                            <>
                                                <div className={"px-2"}>
                                                    <div className={"mb-4"}>
                                                        <h5 className={"text-info fw-bold mb-3"} style={{borderBottom: "2px solid var(--color-border-light)", paddingBottom: "12px"}}>
                                                            <i className={"fe fe-clock me-2"}></i>
                                                            Workflows
                                                        </h5>
                                                    </div>
                                                    {c.workflows.map((w, wIndex) => {
                                                        const hasEscalations = w?.escalations && w.escalations.length > 0;
                                                        return (
                                                        <>
                                                            <div className={`border rounded ${(!hasEscalations || hasIncompletePeriodCoverage(w.escalations)) ? "border-danger" : "border-primary border-shine"} p-4 mt-3 mb-4`}
                                                                 style={{backgroundColor: "var(--color-bg-primary)", boxShadow: "var(--color-border-medium) 0px 0px 4px"}}>
                                                                {/*<div className={"border border-secondary mt-4 mb-3"}></div>*/}
                                                                <div className={"row"}>
                                                                    <div className={"col-md-6"}>
                                                                        {!hasEscalations
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    No escalation set up on workflow
                                                                                </div>
                                                                            : hasIncompletePeriodCoverage(w.escalations)
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    Escalation does not have full coverage
                                                                                </div>
                                                                            :   <></>
                                                                        }
                                                                        <h3 className={"fs-3 mb-3 fw-bold"}>
                                                                            {w.workflow_name}
                                                                            <Button id={`workflow-resident-${cIndex}-edit-btn`} text={"Edit"}
                                                                                    class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                    iconClass={"fe fe-edit me-2"}
                                                                                    onClick={() => {editFlowModal(cIndex, wIndex, c.careflow_type_id)}} />
                                                                        </h3>
                                                                        <div>
                                                                            <h4 className={"text-muted mb-0"}>{convertSecto12Hour(w.window_start)} - {convertSecto12Hour(w.window_end)}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-md-6"}>
                                                                    </div>
                                                                </div>
                                                                <div className={"mt-0"}>
                                                                    {w.escalations && w.escalations.length > 0 && (
                                                                    <>
                                                                        <div className={"mt-4 mb-3"}>
                                                                            <h6 className={"text-info fw-bold mb-3"} style={{borderBottom: "1px solid var(--color-border)", paddingBottom: "8px"}}>
                                                                                <i className={"fe fe-activity me-2"}></i>
                                                                                Escalations
                                                                            </h6>
                                                                        </div>
                                                                        <div className={"mt-3"}>
                                                                            {w.escalations.map((escalation, eIndex) => {
                                                                                const hasOverlap = hasOverlappingEscalations(w.workflow_id, escalation.escalation_id, escalation.period_start, escalation.period_end);
                                                                                return (
                                                                                    <div key={escalation.escalation_id} className={`border bg-white rounded p-3 mb-2 ${hasOverlap ? 'border-warning' : ''}`}
                                                                                         style={{boxShadow: "var(--color-border-medium) 1px 1px 0"}}>
                                                                                        {hasOverlap && (
                                                                                            <div className={"alert alert-warning border-0 mb-3"} style={{
                                                                                                backgroundColor: "#fff3cd",
                                                                                                borderLeft: "4px solid #ffc107",
                                                                                                borderRadius: "6px",
                                                                                                padding: "12px 16px"
                                                                                            }}>
                                                                                                <i className={"fe fe-info me-2"}></i>
                                                                                                Escalation period overlaps with another escalation
                                                                                            </div>
                                                                                        )}
                                                                                        <div className={"d-flex justify-content-between align-items-center"}>
                                                                                            <div>
                                                                                                <h3 className={"fs-4 fw-bold mb-1"}>{escalation.escalation_name}
                                                                                                    <Button id={`escalation-resident-${cIndex}-edit-btn`} text={"Edit"}
                                                                                                            class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                                            iconClass={"fe fe-edit me-2"}
                                                                                                            onClick={() => {editEscModal(cIndex, wIndex, eIndex, c.careflow_type_id)}} />
                                                                                                </h3>
                                                                                                <small className={"text-muted"}>
                                                                                                    Period: {Math.floor(escalation.period_start / 60)} min - {Math.floor(escalation.period_end / 60)} min
                                                                                                </small>
                                                                                            </div>
                                                                                            <button className={"btn btn-sm btn-outline-primary"} style={{minWidth: "100px"}}
                                                                                                    onClick={() => toggleEscalation(w.workflow_id, escalation.escalation_id)}>
                                                                                                {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] ? "Hide Details" : "Show Details"}
                                                                                            </button>
                                                                                        </div>
                                                                                        {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] && (
                                                                                            <div className={"mt-3"}>
                                                                                                {escalation.outputs && escalation.outputs.length > 0 ? (
                                                                                                    <ul className={"list-unstyled"}>
                                                                                                        {escalation.outputs.map((output) => {
                                                                                                            const entWarning = output.enabled && (!output?.entities || output.entities.length === 0) && output.output_type_id !== 9;
                                                                                                            const showOutput = show_output(output);
                                                                                                            return (showOutput ?
                                                                                                                <li key={output.output_id} className={"mb-1"}>
                                                                                                                    <span className={`badge ${entWarning ? 'bg-warning' : output.enabled ? 'bg-success' : 'bg-secondary'} me-2`} style={{minWidth: "58px"}}>
                                                                                                                        {output.enabled ? 'Enabled' : 'Disabled'}
                                                                                                                    </span>
                                                                                                                    {output.output}
                                                                                                                    {output.entities && output.entities.length > 0
                                                                                                                        ? <small className={"text-muted ms-2 fw-bold"}>({output.entities.map(ref => ref.reference_display).join(', ')})</small>
                                                                                                                        : <></>
                                                                                                                    }
                                                                                                                    {output.enabled ? <small className={"text-muted ms-2"}>• {output.repeat_interval > 0 ? `Repeat every ${Math.floor(output.repeat_interval / 60)} min` : 'Sent once'}</small> : <></>}
                                                                                                                </li> : <></>

                                                                                                            )}
                                                                                                        )}
                                                                                                    </ul>
                                                                                                ) : (
                                                                                                    <p className={"text-muted"}>No outputs configured</p>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                    <div className={"d-flex justify-content-end"}>
                                                                        <Button text={"Escalation"} type={"button"}
                                                                                class={"btn btn-info  ms-2 mt-1"} icon={true}
                                                                                iconClass={"fe fe-plus me-2"}
                                                                                onClick={() => addEscModal(cIndex, wIndex, c.careflow_type_id)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        <div className={"d-flex justify-content-start"}>
                                            <Button text={"Workflow"} type={"button"}
                                                    class={"btn btn-primary ms-2 mt-1"} icon={true}
                                                    iconClass={"fe fe-plus me-2"}
                                                    onClick={() => addFlowModal(cIndex, c.careflow_type_id)} />
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className={tabItem === "device" ? "d-block" : "d-none"}>
                        <div style={{maxWidth: "1200px", minWidth: "600px"}}>
                             <div className={"alert alert-info border-0 text-muted"}
                                  style={{
                                     backgroundColor: "#f8f9fa",
                                     borderLeft: "4px solid #007bff",
                                     borderRadius: "8px",
                                     padding: "16px 20px",
                                     marginBottom: "24px",
                                     boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                 }}>
                                 <i className={"fe fe-info me-2 text-info"}></i>
                                 <strong className={"text-info"}>Device Careflow</strong> is the 2nd level of priority in the priority hierarchy and will
                                    apply to any event associated with a specific device when no other higher-priority Careflow takes precedence.
                                    This supersedes all default, area, and resident based careflows.
                             </div>
                        </div>
                        {!dActiveData || dActiveData.length === 0
                             ?   <div className={"row"}>
                                     <div className={"col-12"}>
                                         <div className={"alert alert-warning border-0"} style={{
                                             backgroundColor: "#fff3cd",
                                             borderLeft: "4px solid #ffc107",
                                             borderRadius: "8px",
                                             padding: "20px",
                                             textAlign: "center",
                                             boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                         }}>
                                             <i className={"fe fe-info fs-1 text-warning mb-3 d-block"}></i>
                                             <h4 className={"text-warning mb-0"}>No Device Careflows being utilized.</h4>
                                         </div>
                                     </div>
                                 </div>
                             :   <></>
                        }
                        {dActiveData.map((c, cIndex) => {
                            const hasEntity = c?.entities?.length && c.entities.length > 0;
                            const hasWorkflow = c?.workflows?.length && c.workflows.length > 0;
                            const hasIncompleteDay = hasWorkflow && hasIncompleteDayCoverage(c.workflows);
                            return (
                                <>
                                    <div className={`card px-5 py-4 ${!hasWorkflow ? "border-danger" : !hasEntity ? "border-warning" : hasIncompleteDay ? "border-warning" : ""}`} style={{maxWidth: "1200px", minWidth: "600px"}}>
                                        <div className={"row mb-4"}>
                                            <div className={"col-md-6"}>
                                                {!hasWorkflow
                                                    ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                            backgroundColor: "#f8d7da",
                                                            borderLeft: "4px solid #dc3545",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "var(--color-danger)"
                                                        }}>
                                                            <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                            No workflows set up on careflow
                                                        </div>
                                                    : hasIncompleteDay
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "#f6c343"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            Workflows do not cover the entire day
                                                        </div>
                                                    :   <></>
                                                }
                                                {!hasEntity
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            No assigned device groups
                                                        </div>
                                                    :   <></>
                                                }
                                                <div>
                                                    <h3 className={"fs-3 mb-3 fw-bold"}>{c.careflow_name}
                                                        <Button id={`careflow-device-${cIndex}-edit-btn`} text={"Edit"}
                                                                class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                iconClass={"fe fe-edit me-2"}
                                                                onClick={() => {editCareModal(cIndex, c.careflow_type_id)}} />
                                                    </h3>
                                                    <h4>{c.careflow_description}</h4>
                                                </div>
                                            </div>
                                            <div className={"col-md-6"}>
                                                {c.entities && c.entities.length > 0 && (
                                                    <div className={"text-end"}>
                                                        <div className={"d-flex flex-wrap justify-content-end gap-1"}>
                                                            {c.entities.map((entity, index) => (
                                                                <span key={index} className={"badge bg-info"}
                                                                      title={"Attached area group"}>
                                                                    {entity.reference_name}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {c.workflows && c.workflows.length > 0 && (
                                            <>
                                                <div className={"px-2"}>
                                                    <div className={"mb-4"}>
                                                        <h5 className={"text-info fw-bold mb-3"} style={{borderBottom: "2px solid var(--color-border-light)", paddingBottom: "12px"}}>
                                                            <i className={"fe fe-clock me-2"}></i>
                                                            Workflows
                                                        </h5>
                                                    </div>
                                                    {c.workflows.map((w, wIndex) => {
                                                        const hasEscalations = w?.escalations && w.escalations.length > 0;
                                                        return (
                                                        <>
                                                            <div className={`border rounded ${(!hasEscalations || hasIncompletePeriodCoverage(w.escalations)) ? "border-danger" : "border-primary border-shine"} p-4 mt-3 mb-4`}
                                                                 style={{backgroundColor: "var(--color-bg-primary)", boxShadow: "var(--color-border-medium) 0px 0px 4px"}}>
                                                                {/*<div className={"border border-secondary mt-4 mb-3"}></div>*/}
                                                                <div className={"row"}>
                                                                    <div className={"col-md-6"}>
                                                                        {!hasEscalations
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    No escalation set up on workflow
                                                                                </div>
                                                                            : hasIncompletePeriodCoverage(w.escalations)
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    Escalation does not have full coverage
                                                                                </div>
                                                                            :   <></>
                                                                        }
                                                                        <h3 className={"fs-3 mb-3 fw-bold"}>
                                                                            {w.workflow_name}
                                                                            <Button id={`workflow-device-${cIndex}-edit-btn`} text={"Edit"}
                                                                                    class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                    iconClass={"fe fe-edit me-2"}
                                                                                    onClick={() => {editFlowModal(cIndex, wIndex, c.careflow_type_id)}} />
                                                                        </h3>
                                                                        <div>
                                                                            <h4 className={"text-muted mb-0"}>{convertSecto12Hour(w.window_start)} - {convertSecto12Hour(w.window_end)}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-md-6"}>
                                                                    </div>
                                                                </div>
                                                                <div className={"mt-0"}>
                                                                    {w.escalations && w.escalations.length > 0 && (
                                                                    <>
                                                                        <div className={"mt-4 mb-3"}>
                                                                            <h6 className={"text-info fw-bold mb-3"} style={{borderBottom: "1px solid var(--color-border)", paddingBottom: "8px"}}>
                                                                                <i className={"fe fe-activity me-2"}></i>
                                                                                Escalations
                                                                            </h6>
                                                                        </div>
                                                                        <div className={"mt-3"}>
                                                                            {w.escalations.map((escalation, eIndex) => {
                                                                                const hasOverlap = hasOverlappingEscalations(w.workflow_id, escalation.escalation_id, escalation.period_start, escalation.period_end);
                                                                                return (
                                                                                    <div key={escalation.escalation_id} className={`border bg-white rounded p-3 mb-2 ${hasOverlap ? 'border-warning' : ''}`}
                                                                                         style={{boxShadow: "var(--color-border-medium) 1px 1px 0"}}>
                                                                                        {hasOverlap && (
                                                                                            <div className={"alert alert-warning border-0 mb-3"} style={{
                                                                                                backgroundColor: "#fff3cd",
                                                                                                borderLeft: "4px solid #ffc107",
                                                                                                borderRadius: "6px",
                                                                                                padding: "12px 16px"
                                                                                            }}>
                                                                                                <i className={"fe fe-info me-2"}></i>
                                                                                                Escalation period overlaps with another escalation
                                                                                            </div>
                                                                                        )}
                                                                                        <div className={"d-flex justify-content-between align-items-center"}>
                                                                                            <div>
                                                                                                <h3 className={"fs-4 fw-bold mb-1"}>{escalation.escalation_name}
                                                                                                    <Button id={`escalation-device-${cIndex}-edit-btn`} text={"Edit"}
                                                                                                            class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                                            iconClass={"fe fe-edit me-2"}
                                                                                                            onClick={() => {editEscModal(cIndex, wIndex, eIndex, c.careflow_type_id)}} />
                                                                                                </h3>
                                                                                                <small className={"text-muted"}>
                                                                                                    Period: {Math.floor(escalation.period_start / 60)} min - {Math.floor(escalation.period_end / 60)} min
                                                                                                </small>
                                                                                            </div>
                                                                                            <button className={"btn btn-sm btn-outline-primary"} style={{minWidth: "100px"}}
                                                                                                    onClick={() => toggleEscalation(w.workflow_id, escalation.escalation_id)}>
                                                                                                {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] ? "Hide Details" : "Show Details"}
                                                                                            </button>
                                                                                        </div>
                                                                                        {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] && (
                                                                                            <div className={"mt-3"}>
                                                                                                {escalation.outputs && escalation.outputs.length > 0 ? (
                                                                                                    <ul className={"list-unstyled"}>
                                                                                                        {escalation.outputs.map((output) => {
                                                                                                            const entWarning = output.enabled && (!output?.entities || output.entities.length === 0) && output.output_type_id !== 9;
                                                                                                            const showOutput = show_output(output);
                                                                                                            return (showOutput ?
                                                                                                                <li key={output.output_id} className={"mb-1"}>
                                                                                                                    <span className={`badge ${entWarning ? 'bg-warning' : output.enabled ? 'bg-success' : 'bg-secondary'} me-2`} style={{minWidth: "58px"}}>
                                                                                                                        {output.enabled ? 'Enabled' : 'Disabled'}
                                                                                                                    </span>
                                                                                                                    {output.output}
                                                                                                                    {output.entities && output.entities.length > 0
                                                                                                                        ? <small className={"text-muted ms-2 fw-bold"}>({output.entities.map(ref => ref.reference_display).join(', ')})</small>
                                                                                                                        : <></>
                                                                                                                    }
                                                                                                                    {output.enabled ? <small className={"text-muted ms-2"}>• {output.repeat_interval > 0 ? `Repeat every ${Math.floor(output.repeat_interval / 60)} min` : 'Sent once'}</small> : <></>}
                                                                                                                </li> : <></>

                                                                                                            )}
                                                                                                        )}
                                                                                                    </ul>
                                                                                                ) : (
                                                                                                    <p className={"text-muted"}>No outputs configured</p>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                    <div className={"d-flex justify-content-end"}>
                                                                        <Button text={"Escalation"} type={"button"}
                                                                                class={"btn btn-info  ms-2 mt-1"} icon={true}
                                                                                iconClass={"fe fe-plus me-2"}
                                                                                onClick={() => addEscModal(cIndex, wIndex, c.careflow_type_id)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        <div className={"d-flex justify-content-start"}>
                                            <Button text={"Workflow"} type={"button"}
                                                    class={"btn btn-primary ms-2 mt-1"} icon={true}
                                                    iconClass={"fe fe-plus me-2"}
                                                    onClick={() => addFlowModal(cIndex, c.careflow_type_id)} />
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                    <div className={tabItem === "event" ? "d-block" : "d-none"}>
                        <div style={{maxWidth: "1200px", minWidth: "600px"}}>
                             <div className={"alert alert-info border-0 text-muted"}
                                  style={{
                                     backgroundColor: "#f8f9fa",
                                     borderLeft: "4px solid #007bff",
                                     borderRadius: "8px",
                                     padding: "16px 20px",
                                     marginBottom: "24px",
                                     boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                 }}>
                                 <i className={"fe fe-info me-2 text-info"}></i>
                                 <strong className={"text-info"}>Event Careflow</strong> is the highest priority careflow and supercedes all other careflows for any event that is
                                    an associated event type with the Careflow.
                             </div>
                        </div>
                        {!eActiveData || eActiveData.length === 0
                             ?   <div className={"row"}>
                                     <div className={"col-12"}>
                                         <div className={"alert alert-warning border-0"} style={{
                                             backgroundColor: "#fff3cd",
                                             borderLeft: "4px solid #ffc107",
                                             borderRadius: "8px",
                                             padding: "20px",
                                             textAlign: "center",
                                             boxShadow: "0 1px 3px rgba(0,0,0,0.1)"
                                         }}>
                                             <i className={"fe fe-info fs-1 text-warning mb-3 d-block"}></i>
                                             <h4 className={"text-warning mb-0"}>No event based Careflows being utilized.</h4>
                                         </div>
                                     </div>
                                 </div>
                             :   <></>
                        }
                        {eActiveData.map((c, cIndex) => {
                            const hasWorkflow = c?.workflows?.length && c.workflows.length > 0;
                            const hasIncompleteDay = hasWorkflow && hasIncompleteDayCoverage(c.workflows);
                            return (
                                <>
                                    <div className={`card px-5 py-4 ${!hasWorkflow ? "border-danger" : hasIncompleteDay ? "border-warning" : ""}`} style={{maxWidth: "1200px", minWidth: "600px"}}>
                                        <div className={"row mb-4"}>
                                            <div className={"col-md-6"}>
                                                {!hasWorkflow
                                                    ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                            backgroundColor: "#f8d7da",
                                                            borderLeft: "4px solid #dc3545",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "var(--color-danger)"
                                                        }}>
                                                            <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                            No workflows set up on careflow
                                                        </div>
                                                    : hasIncompleteDay
                                                    ?   <div className={"alert alert-warning border-0 mb-3"} style={{
                                                            backgroundColor: "#fff3cd",
                                                            borderLeft: "4px solid #ffc107",
                                                            borderRadius: "6px",
                                                            padding: "12px 16px",
                                                            color: "#f6c343"
                                                        }}>
                                                            <i className={"fe fe-info me-2"}></i>
                                                            Workflows do not cover the entire day
                                                        </div>
                                                    :   <></>
                                                }
                                                <div>
                                                    <h3 className={"fs-3 mb-3 fw-bold"}>{c.careflow_name}
                                                        <Button id={`careflow-event-${cIndex}-edit-btn`} text={"Edit"}
                                                                class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                iconClass={"fe fe-edit me-2"}
                                                                onClick={() => {editCareModal(cIndex, c.careflow_type_id)}} />
                                                    </h3>
                                                    <h4>{c.careflow_description}</h4>
                                                </div>
                                                <div>
                                                    <h4 className={"text-muted"}>{c.event_category_name} - {c.event_type_name}</h4>
                                                </div>
                                            </div>
                                            <div className={"col-md-6"}>
                                                {c.entities && c.entities.length > 0 && (
                                                    <div className={"text-end"}>
                                                        <div className={"d-flex flex-wrap justify-content-end gap-1"}>
                                                            {c.entities.map((entity, index) => (
                                                                <span key={index} className={"badge bg-info"}
                                                                      title={"Attached area group"}>
                                                                    {entity.reference_name}
                                                                </span>
                                                            ))}
                                                        </div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                        {c.workflows && c.workflows.length > 0 && (
                                            <>
                                                <div className={"px-2"}>
                                                    <div className={"mb-4"}>
                                                        <h5 className={"text-info fw-bold mb-3"} style={{borderBottom: "2px solid var(--color-border-light)", paddingBottom: "12px"}}>
                                                            <i className={"fe fe-clock me-2"}></i>
                                                            Workflows
                                                        </h5>
                                                    </div>
                                                    {c.workflows.map((w, wIndex) => {
                                                        const hasEscalations = w?.escalations && w.escalations.length > 0;
                                                        return (
                                                        <>
                                                            <div className={`border rounded ${(!hasEscalations || hasIncompletePeriodCoverage(w.escalations)) ? "border-danger" : "border-primary border-shine"} p-4 mt-3 mb-4`}
                                                                 style={{backgroundColor: "var(--color-bg-primary)", boxShadow: "var(--color-border-medium) 0px 0px 4px"}}>
                                                                {/*<div className={"border border-secondary mt-4 mb-3"}></div>*/}
                                                                <div className={"row"}>
                                                                    <div className={"col-md-6"}>
                                                                        {!hasEscalations
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    No escalation set up on workflow
                                                                                </div>
                                                                            : hasIncompletePeriodCoverage(w.escalations)
                                                                            ?   <div className={"alert alert-danger border-0 mb-3"} style={{
                                                                                    backgroundColor: "#f8d7da",
                                                                                    borderLeft: "4px solid #dc3545",
                                                                                    borderRadius: "6px",
                                                                                    padding: "12px 16px",
                                                                                    color: "var(--color-danger)"
                                                                                }}>
                                                                                    <i className={"fe fe-alert-triangle me-2"} style={{color: "var(--color-danger)"}}></i>
                                                                                    Escalation does not have full coverage
                                                                                </div>
                                                                            :   <></>
                                                                        }
                                                                        <h3 className={"fs-3 mb-3 fw-bold"}>
                                                                            {w.workflow_name}
                                                                            <Button id={`workflow-event-${cIndex}-edit-btn`} text={"Edit"}
                                                                                    class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                    iconClass={"fe fe-edit me-2"}
                                                                                    onClick={() => {editFlowModal(cIndex, wIndex, c.careflow_type_id)}} />
                                                                        </h3>
                                                                        <div>
                                                                            <h4 className={"text-muted mb-0"}>{convertSecto12Hour(w.window_start)} - {convertSecto12Hour(w.window_end)}</h4>
                                                                        </div>
                                                                    </div>
                                                                    <div className={"col-md-6"}>
                                                                    </div>
                                                                </div>
                                                                <div className={"mt-0"}>
                                                                    {w.escalations && w.escalations.length > 0 && (
                                                                    <>
                                                                        <div className={"mt-4 mb-3"}>
                                                                            <h6 className={"text-info fw-bold mb-3"} style={{borderBottom: "1px solid var(--color-border)", paddingBottom: "8px"}}>
                                                                                <i className={"fe fe-activity me-2"}></i>
                                                                                Escalations
                                                                            </h6>
                                                                        </div>
                                                                        <div className={"mt-3"}>
                                                                            {w.escalations.map((escalation, eIndex) => {
                                                                                const hasOverlap = hasOverlappingEscalations(w.workflow_id, escalation.escalation_id, escalation.period_start, escalation.period_end);
                                                                                return (
                                                                                    <div key={escalation.escalation_id} className={`border bg-white rounded p-3 mb-2 ${hasOverlap ? 'border-warning' : ''}`}
                                                                                         style={{boxShadow: "var(--color-border-medium) 1px 1px 0"}}>
                                                                                        {hasOverlap && (
                                                                                            <div className={"alert alert-warning border-0 mb-3"} style={{
                                                                                                backgroundColor: "#fff3cd",
                                                                                                borderLeft: "4px solid #ffc107",
                                                                                                borderRadius: "6px",
                                                                                                padding: "12px 16px"
                                                                                            }}>
                                                                                                <i className={"fe fe-info me-2"}></i>
                                                                                                Escalation period overlaps with another escalation
                                                                                            </div>
                                                                                        )}
                                                                                        <div className={"d-flex justify-content-between align-items-center"}>
                                                                                            <div>
                                                                                                <h3 className={"fs-4 fw-bold mb-1"}>{escalation.escalation_name}
                                                                                                    <Button id={`escalation-event-${cIndex}-edit-btn`} text={"Edit"}
                                                                                                            class={"btn btn-sm btn-outline-primary ms-4"} icon={true}
                                                                                                            iconClass={"fe fe-edit me-2"}
                                                                                                            onClick={() => {editEscModal(cIndex, wIndex, eIndex, c.careflow_type_id)}} />
                                                                                                </h3>
                                                                                                <small className={"text-muted"}>
                                                                                                    Period: {Math.floor(escalation.period_start / 60)} min - {Math.floor(escalation.period_end / 60)} min
                                                                                                </small>
                                                                                            </div>
                                                                                            <button className={"btn btn-sm btn-outline-primary"} style={{minWidth: "100px"}}
                                                                                                    onClick={() => toggleEscalation(w.workflow_id, escalation.escalation_id)}>
                                                                                                {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] ? "Hide Details" : "Show Details"}
                                                                                            </button>
                                                                                        </div>
                                                                                        {expandedEscalations[`${w.workflow_id}-${escalation.escalation_id}`] && (
                                                                                            <div className={"mt-3"}>
                                                                                                {escalation.outputs && escalation.outputs.length > 0 ? (
                                                                                                    <ul className={"list-unstyled"}>
                                                                                                        {escalation.outputs.map((output) => {
                                                                                                            const entWarning = output.enabled && (!output?.entities || output.entities.length === 0) && output.output_type_id !== 9;
                                                                                                            const showOutput = show_output(output);
                                                                                                            return (showOutput ?
                                                                                                                <li key={output.output_id} className={"mb-1"}>
                                                                                                                    <span className={`badge ${entWarning ? 'bg-warning' : output.enabled ? 'bg-success' : 'bg-secondary'} me-2`} style={{minWidth: "58px"}}>
                                                                                                                        {output.enabled ? 'Enabled' : 'Disabled'}
                                                                                                                    </span>
                                                                                                                    {output.output}
                                                                                                                    {output.entities && output.entities.length > 0
                                                                                                                        ? <small className={"text-muted ms-2 fw-bold"}>({output.entities.map(ref => ref.reference_display).join(', ')})</small>
                                                                                                                        : <></>
                                                                                                                    }
                                                                                                                    {output.enabled ? <small className={"text-muted ms-2"}>• {output.repeat_interval > 0 ? `Repeat every ${Math.floor(output.repeat_interval / 60)} min` : 'Sent once'}</small> : <></>}
                                                                                                                </li> : <></>
                                                                                                            )}
                                                                                                        )}
                                                                                                    </ul>
                                                                                                ) : (
                                                                                                    <p className={"text-muted"}>No outputs configured</p>
                                                                                                )}
                                                                                            </div>
                                                                                        )}
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </>
                                                                )}
                                                                    <div className={"d-flex justify-content-end"}>
                                                                        <Button text={"Escalation"} type={"button"}
                                                                                class={"btn btn-info  ms-2 mt-1"} icon={true}
                                                                                iconClass={"fe fe-plus me-2"}
                                                                                onClick={() => addEscModal(cIndex, wIndex, c.careflow_type_id)} />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </>
                                                        );
                                                    })}
                                                </div>
                                            </>
                                        )}
                                        <div className={"d-flex justify-content-start"}>
                                            <Button text={"Workflow"} type={"button"}
                                                    class={"btn btn-primary ms-2 mt-1"} icon={true}
                                                    iconClass={"fe fe-plus me-2"}
                                                    onClick={() => addFlowModal(cIndex, c.careflow_type_id)} />
                                        </div>
                                    </div>
                                </>
                            );
                        })}
                    </div>
                </div>
                <div className={"modal fade"} id={"caremodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>{outputOp} Careflow</h2>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                            </div>
                            <form id={"careForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"w-100 d-inline-block"}>
                                        <div className={"form-floating mb-3"}>
                                            <input type={"text"} className={"form-control"} id={"careflow-name"}
                                                   onKeyUp={() => formCheck("careForm", "careSubmit")}
                                                   required={true} pattern={"^[0-9a-zA-Z_\\- ]+"}/>
                                            <label htmlFor={"careflow-name"}>Name</label>
                                            <div className={"invalid-feedback"}>
                                                Please enter a name!
                                            </div>
                                        </div>
                                        <div className={"form-floating mb-3"}>
                                            <textarea className={"form-control pt-5"} id={"careflow-desc"}
                                                      required={false} style={{height: "75px"}}
                                                      onKeyUp={() => formCheck("careForm", "careSubmit")}>
                                            </textarea>
                                            <label htmlFor={"careflow-desc"} className={"form-label"}>Description</label>
                                        </div>
                                        <div className={"mt-4 row"} id={"careflow-event-selector"}>
                                            <div className={"form-floating mb-3 col-6"}>
                                                <select className={"form-select"} id={"event-category"}
                                                        onChange={(e) => {
                                                            formCheck("careForm", "careSubmit");
                                                            setEventCatId(parseInt(e.target.value));
                                                        }}>
                                                    <option value={null} disabled={true}></option>
                                                    {eventCatOptions}
                                                </select>
                                                <label className={"ms-3"} htmlFor={"event-category"}>Event Category</label>
                                            </div>
                                            <div className={"form-floating mb-3 col-6"}>
                                                <select className={"form-select"} id={"event-type"}
                                                        onChange={() => {
                                                            formCheck("careForm", "careSubmit");
                                                        }}>
                                                    <option value={null} disabled={true}></option>
                                                    {eventTypeOptions}
                                                </select>
                                                <label className={"ms-3"} htmlFor={"event-type"}>Event Type</label>
                                            </div>
                                        </div>
                                    </div>
                                    <hr/>
                                    <div className={"mt-1"} id={"area-group-selector"}>
                                        <h3>Area Groups</h3>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"agSearch"} className={"form-control search-input"}
                                                   value={areaGroupSearch}
                                                   onChange={(e) => setAreaGroupSearch(e.target.value)} />
                                            <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                        </div>
                                        <div className={"form-check d-inline-block ms-5 mb-3"}>
                                            <input className={"form-check-input form-check-med"} id={"areagroup-show"}
                                                   style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                                   type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                       setShowChecked(e.target.checked);
                                            }} />
                                            <label className={"form-check-label text-dark"} htmlFor={"areagroup-show"}>Show selected only</label>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover d-sm-table"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {areaGroupTableHeader}
                                                </thead>
                                                <tbody>
                                                    {areaGroupTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={"mt-1"} id={"res-group-selector"}>
                                        <h3>Resident Groups</h3>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"rgSearch"} className={"form-control search-input"}
                                                   value={resGroupSearch}
                                                   onChange={(e) => setResGroupSearch(e.target.value)} />
                                            <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                        </div>
                                        <div className={"form-check d-inline-block ms-5 mb-3"}>
                                            <input className={"form-check-input form-check-med"} id={"resgroup-show"}
                                                   style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                                   type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                       setShowChecked(e.target.checked);
                                            }} />
                                            <label className={"form-check-label text-dark"} htmlFor={"resgroup-show"}>Show selected only</label>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover d-sm-table"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {resGroupTableHeader}
                                                </thead>
                                                <tbody>
                                                    {resGroupTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                    <div className={"mt-1"} id={"dev-selector"}>
                                        <h3>Devices</h3>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"}>
                                            <input type={"search"} id={"dSearch"} className={"form-control search-input"}
                                                   value={devSearch}
                                                   onChange={(e) => setDevSearch(e.target.value)} />
                                            <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                        </div>
                                        <div className={"form-check d-inline-block ms-5 mb-3"}>
                                            <input className={"form-check-input form-check-med"} id={"devices-show"}
                                                   style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                                   type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                       setShowChecked(e.target.checked);
                                            }} />
                                            <label className={"form-check-label text-dark"} htmlFor={"devices-show"}>Show selected only</label>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}}>
                                            <table className={"table table-sm table-white table-hover d-sm-table"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {devTableHeader}
                                                </thead>
                                                <tbody>
                                                    {devTableRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                    <div>
                                        {outputOp === "Edit"
                                            ?   <Button id={"careflow-delete-btn"} text={"Delete"} class={"btn btn-danger"}
                                                        icon={true} iconClass={"fe fe-trash-2 me-2"}
                                                        onClick={() => swapModal("cancelCareBtn", "careconfirmmodal")} />

                                            :   <></>
                                        }
                                    </div>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"cancelCareBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadCareSubmit"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => {
                                            if (outputOp === "Add"){
                                                addCareflowSubmit();
                                            }else{
                                                editCareflowSubmit();
                                            }
                                        }} id={"careSubmit"}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"flowmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>{outputOp} Workflow</h2>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                            </div>
                            <form id={"flowForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"w-100 d-inline-block"}>
                                        <div className={"form-floating mb-3"}>
                                            <input type={"text"} className={"form-control"} id={"workflow-name"}
                                                   onKeyUp={() => formCheck("flowForm", "flowSubmit")}
                                                   required={true} pattern={"^[0-9a-zA-Z_\\- ]+"}/>
                                            <label htmlFor={"workflow-name"}>Name</label>
                                            <div className={"invalid-feedback"}>
                                                Please enter a name!
                                            </div>
                                        </div>
                                        <div className={"mt-4"} id={"mute-container"}>
                                            <h3 className={"d-inline-block"} style={{minWidth: "120px"}}>Workflow is Muted?</h3>
                                            <div className={"d-inline-block form-check form-switch ms-5 align-middle"}>
                                                <input name={"add-alarm-on"} id={"workflow-mute"} defaultChecked={false}
                                                       className={"form-check-input"} type={"checkbox"} onChange={(e) => {
                                                           formCheck("flowForm", "flowSubmit");
                                                       }} />
                                            </div>
                                        </div>
                                        <DayTimeRangeSlider start={startTime} end={endTime}
                                                            setStart={setStartTime} setEnd={setEndTime} />
                                    </div>
                                </div>
                                <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                    <div>
                                        {outputOp === "Edit"
                                            ?   <Button id={"workflow-delete-btn"} text={"Delete"} class={"btn btn-danger"}
                                                        icon={true} iconClass={"fe fe-trash-2 me-2"}
                                                        onClick={() => swapModal("cancelFlowBtn", "flowconfirmmodal")} />

                                            :   <></>
                                        }
                                    </div>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"cancelFlowBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadFlowSubmit"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => {
                                            if (outputOp === "Add"){
                                                addWorkflowSubmit();
                                            }else{
                                                editWorkflowSubmit();
                                            }
                                        }} id={"flowSubmit"}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"escmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticEscBackdropLabel"}>{outputOp} Escalation</h2>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                            </div>
                            <form id={"escForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"w-100 d-inline-block"}>
                                        <div className={"form-floating mb-3"}>
                                            <input type={"text"} className={"form-control"} id={"esc-name"}
                                                   onKeyUp={() => formCheck("escForm", "escSubmit")}
                                                   required={true} pattern={"^[0-9a-zA-Z_\\- ]+"}/>
                                            <label htmlFor={"esc-name"}>Name</label>
                                            <div className={"invalid-feedback"}>
                                                Please enter a name!
                                            </div>
                                        </div>
                                        <MinTimeRangeSlider start={escStartTime} end={escEndTime}
                                                            setStart={setEscStartTime} setEnd={setEscEndTime}
                                                            minTime={escMin} maxTime={escMax} />
                                        <hr/>
                                        <div className={"mb-3"}>
                                            <h3 className={"mb-0"}>Escalation Output Settings</h3>
                                            <small className={"text-muted ms-1"}>Repeat of zero indicates only send once</small>
                                        </div>
                                        {mobileOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-mobile"} onChange={(e) => {
                                                                       if (e.target.checked){
                                                                           document.getElementById("esc-mobile-repeat").required = true;
                                                                           document.getElementById("esc-mobile-repeat").disabled = false;
                                                                           document.getElementById("esc-mobile-repeat").value = 0;
                                                                           document.getElementById("user-group-mobile-btn").classList.remove("d-none");
                                                                           document.getElementById("esc-mobile-repeat-div").classList.remove("d-none");
                                                                       }else{
                                                                           document.getElementById("esc-mobile-repeat").value = null;
                                                                           document.getElementById("esc-mobile-repeat").required = false;
                                                                           document.getElementById("esc-mobile-repeat").disabled = true;
                                                                           document.getElementById("user-group-mobile-btn").classList.add("d-none");
                                                                           document.getElementById("esc-mobile-repeat-div").classList.add("d-none");
                                                                       }
                                                            }} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-mobile"}>
                                                                Mobile
                                                            </label>
                                                        </div>
                                                        <div className={"d-block"} id={"esc-mobile-repeat-div"}>
                                                            <span>Repeat every </span>
                                                            <input type={"number"} className={"form-control w-auto d-inline py-1"}
                                                                   id={"esc-mobile-repeat"} min={0} max={60} required={false}
                                                                   disabled={true} />
                                                            <span> min</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button text={`Attach ${userGroupMobileIdList.length}/${userGroupData.length}`}
                                                                id={"user-group-mobile-btn"} class={"btn btn-outline-primary mt-2 d-none"}
                                                                icon={true} iconClass={"fe fe-users me-2"} onClick={() => {
                                                                    setShowChecked(false);
                                                                    document.getElementById("user-group-selector-mobile").classList.remove("d-none");
                                                                    document.getElementById("user-group-selector-pager").classList.add("d-none");
                                                                    swapModal("cancelEscBtn", "usergroupmodal");
                                                                }}/>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                        {pagerOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-pager"} onChange={(e) => {
                                                                       if (e.target.checked){
                                                                           document.getElementById("esc-pager-repeat").required = true;
                                                                           document.getElementById("esc-pager-repeat").disabled = false;
                                                                           document.getElementById("esc-pager-repeat").value = 0;
                                                                           document.getElementById("user-group-pager-btn").classList.remove("d-none");
                                                                           document.getElementById("esc-pager-repeat-div").classList.remove("d-none");
                                                                       }else{
                                                                           document.getElementById("esc-pager-repeat").value = null;
                                                                           document.getElementById("esc-pager-repeat").required = false;
                                                                           document.getElementById("esc-pager-repeat").disabled = true;
                                                                           document.getElementById("user-group-pager-btn").classList.add("d-none");
                                                                           document.getElementById("esc-pager-repeat-div").classList.add("d-none");
                                                                       }
                                                            }} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-pager"}>
                                                                Pager
                                                            </label>
                                                        </div>
                                                        <div className={"d-block"} id={"esc-pager-repeat-div"}>
                                                            <span>Repeat every </span>
                                                            <input type={"number"} className={"form-control w-auto d-inline py-1"}
                                                                   id={"esc-pager-repeat"} min={0} max={60} required={false}
                                                                   disabled={true} />
                                                            <span> min</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button text={`Attach ${userGroupPagerIdList.length}/${userGroupData.length}`}
                                                                id={"user-group-pager-btn"} class={"btn btn-outline-primary mt-2 d-none"}
                                                                icon={true} iconClass={"fe fe-users me-2"} onClick={() => {
                                                                    setShowChecked(false);
                                                                    document.getElementById("user-group-selector-mobile").classList.add("d-none");
                                                                    document.getElementById("user-group-selector-pager").classList.remove("d-none");
                                                                    swapModal("cancelEscBtn", "usergroupmodal");
                                                                }}/>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                        {textOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-text"} onChange={(e) => {
                                                                       if (e.target.checked){
                                                                           // document.getElementById("esc-text-repeat").required = true;
                                                                           // document.getElementById("esc-text-repeat").disabled = false;
                                                                           document.getElementById("esc-text-repeat").value = 0;
                                                                           document.getElementById("user-group-text-btn").classList.remove("d-none");
                                                                           // document.getElementById("esc-text-repeat-div").classList.remove("d-none");
                                                                       }else{
                                                                           document.getElementById("esc-text-repeat").value = null;
                                                                           // document.getElementById("esc-text-repeat").required = false;
                                                                           // document.getElementById("esc-text-repeat").disabled = true;
                                                                           document.getElementById("user-group-text-btn").classList.add("d-none");
                                                                           // document.getElementById("esc-text-repeat-div").classList.add("d-none");
                                                                       }
                                                            }} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-text"}>
                                                                Text
                                                            </label>
                                                        </div>
                                                        <div className={"d-none"} id={"esc-text-repeat-div"}>
                                                            <span>Repeat every </span>
                                                            <input type={"number"} className={"form-control w-auto d-inline py-1"}
                                                                   id={"esc-text-repeat"} min={0} max={60} required={false}
                                                                   disabled={true} />
                                                            <span> min</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button text={`Attach ${userTextIdList.length}/${userData.length}`}
                                                                id={"user-group-text-btn"} class={"btn btn-outline-primary mt-2 d-none"}
                                                                icon={true} iconClass={"fe fe-users me-2"} onClick={() => {
                                                                    setShowChecked(false);
                                                                    document.getElementById("user-selector-text").classList.remove("d-none");
                                                                    document.getElementById("user-selector-voice").classList.add("d-none");
                                                                    document.getElementById("user-selector-email").classList.add("d-none");
                                                                    swapModal("cancelEscBtn", "usermodal");
                                                                }}/>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                        {emailOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-email"} onChange={(e) => {
                                                                       if (e.target.checked){
                                                                           // document.getElementById("esc-email-repeat").required = true;
                                                                           // document.getElementById("esc-email-repeat").disabled = false;
                                                                           document.getElementById("esc-email-repeat").value = 0;
                                                                           document.getElementById("user-group-email-btn").classList.remove("d-none");
                                                                           // document.getElementById("esc-email-repeat-div").classList.remove("d-none");
                                                                       }else{
                                                                           document.getElementById("esc-email-repeat").value = null;
                                                                           // document.getElementById("esc-email-repeat").required = false;
                                                                           // document.getElementById("esc-email-repeat").disabled = true;
                                                                           document.getElementById("user-group-email-btn").classList.add("d-none");
                                                                           // document.getElementById("esc-email-repeat-div").classList.add("d-none");
                                                                       }
                                                            }} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-email"}>
                                                                Email
                                                            </label>
                                                        </div>
                                                        <div className={"d-none"} id={"esc-email-repeat-div"}>
                                                            <span>Repeat every </span>
                                                            <input type={"number"} className={"form-control w-auto d-inline py-1"}
                                                                   id={"esc-email-repeat"} min={0} max={60} required={false}
                                                                   disabled={true} />
                                                            <span> min</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button text={`Attach ${userEmailIdList.length}/${userData.length}`}
                                                                id={"user-group-email-btn"} class={"btn btn-outline-primary mt-2 d-none"}
                                                                icon={true} iconClass={"fe fe-users me-2"}
                                                                onClick={() => {
                                                                    setShowChecked(false);
                                                                    document.getElementById("user-selector-text").classList.add("d-none");
                                                                    document.getElementById("user-selector-voice").classList.add("d-none");
                                                                    document.getElementById("user-selector-email").classList.remove("d-none");
                                                                    swapModal("cancelEscBtn", "usermodal");
                                                                }}/>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                        {voiceOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-voice"} onChange={(e) => {
                                                                       if (e.target.checked){
                                                                           // document.getElementById("esc-voice-repeat").required = true;
                                                                           // document.getElementById("esc-voice-repeat").disabled = false;
                                                                           document.getElementById("esc-voice-repeat").value = 0;
                                                                           document.getElementById("user-group-voice-btn").classList.remove("d-none");
                                                                           // document.getElementById("esc-voice-repeat-div").classList.remove("d-none");
                                                                       }else{
                                                                           document.getElementById("esc-voice-repeat").value = null;
                                                                           // document.getElementById("esc-voice-repeat").required = false;
                                                                           // document.getElementById("esc-voice-repeat").disabled = true;
                                                                           document.getElementById("user-group-voice-btn").classList.add("d-none");
                                                                           // document.getElementById("esc-voice-repeat-div").classList.add("d-none");
                                                                       }
                                                            }} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-voice"}>
                                                                Voice
                                                            </label>
                                                        </div>
                                                        <div className={"d-none"} id={"esc-voice-repeat-div"}>
                                                            <span>Repeat every </span>
                                                            <input type={"number"} className={"form-control w-auto d-inline py-1"}
                                                                   id={"esc-voice-repeat"} min={0} max={60} required={false}
                                                                   disabled={true} />
                                                            <span> min</span>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Button text={`Attach ${userVoiceIdList.length}/${userData.length}`}
                                                                id={"user-group-voice-btn"} class={"btn btn-outline-primary mt-2 d-none"}
                                                                icon={true} iconClass={"fe fe-users me-2"} onClick={() => {
                                                                    setShowChecked(false);
                                                                    document.getElementById("user-selector-text").classList.add("d-none");
                                                                    document.getElementById("user-selector-voice").classList.remove("d-none");
                                                                    document.getElementById("user-selector-email").classList.add("d-none");
                                                                    swapModal("cancelEscBtn", "usermodal");
                                                                }}/>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                        {offsiteOn
                                            ?   <div className={"d-flex justify-content-between"}>
                                                    <div className={"my-2"}>
                                                        <div className={"form-check form-switch"}>
                                                            <input className={"form-check-input"} type={"checkbox"}
                                                                   id={"esc-offsite"} />
                                                            <label className={"form-check-label text-dark"}
                                                                   htmlFor={"esc-offsite"}>
                                                                Offsite Monitoring
                                                            </label>
                                                        </div>
                                                    </div>
                                                </div>
                                            :   <></>
                                        }
                                    </div>
                                </div>
                                <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                    <div>
                                        {outputOp === "Edit"
                                            ?   <Button id={"escalation-delete-btn"} text={"Delete"}
                                                        class={"btn btn-danger"} icon={true}
                                                        iconClass={"fe fe-trash-2 me-2"}
                                                        onClick={() => swapModal("cancelEscBtn", "escconfirmmodal")} />
                                            :   <></>
                                        }
                                    </div>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary"} id={"cancelEscBtn"} data-bs-dismiss={"modal"}>Cancel</button>
                                        <Button type={"button"} class={"btn btn-primary d-none ms-3"} disabled={true} spinner={true} text={"Loading"} id={"loadEscSubmit"}/>
                                        <button type={"button"} className={"btn btn-primary ms-3"} onClick={() => {
                                            if (outputOp === "Add") {addEscalationSubmit()} else {editEscalationSubmit()}
                                        }} id={"escSubmit"}>Submit</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"usergroupmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticUserGroupBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticEditBackdropLabel"}>Attach User Groups</h2>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                            </div>
                            <form id={"userGroupForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"w-100 d-inline-block"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"} id={"user-group-selector-search"}>
                                            <input type={"search"} id={"user-group-search"} className={"form-control search-input"}
                                                   value={userGroupSearch}
                                                   onChange={(e) => setUserGroupSearch(e.target.value)} />
                                            <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                        </div>
                                        <div className={"form-check d-inline-block ms-5 mb-3"}>
                                            <input className={"form-check-input form-check-med"} id={"usergroup-show"}
                                                   style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                                   type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                       setShowChecked(e.target.checked);
                                            }} />
                                            <label className={"form-check-label text-dark"} htmlFor={"usergroup-show"}>Show selected only</label>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}} id={"user-group-selector-mobile"}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {uGroupMobileTableHeader}
                                                </thead>
                                                <tbody>
                                                    {userGroupMobileRows}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}} id={"user-group-selector-pager"}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {uGroupPagerTableHeader}
                                                </thead>
                                                <tbody>
                                                    {userGroupPagerRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                    <div>
                                    </div>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary d-none"} id={"cancelUserGroupBtn"}
                                                data-bs-dismiss={"modal"} onClick={() => {

                                        }}>Cancel</button>
                                        <button type={"button"} className={"btn btn-primary ms-3"}
                                                onClick={() => {swapModal("cancelUserGroupBtn", "escmodal")}}
                                                id={"userGroupSubmit"}>
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"usermodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                     tabIndex={-1} aria-labelledby={"staticEditBackdropLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticUserBackdropLabel"}>Attach Users</h2>
                                <button type={"button"} className={"btn-close"} data-bs-dismiss={"modal"} aria-label={"Close"} />
                            </div>
                            <form id={"userForm"} className={"was-validated"}>
                                <div className={"modal-body"}>
                                    <div className={"w-100 d-inline-block"}>
                                        <div className={"form-outline d-inline-flex align-bottom ms-2 my-3"} id={"user-selector-search"}>
                                            <input type={"search"} id={"user-search"} className={"form-control search-input"}
                                                   value={userSearch}
                                                   onChange={(e) => setUserSearch(e.target.value)} />
                                            <Button text={""} type={"button"} class={"btn btn-primary smooth-radius-left"}
                                                    style={{height: "42px"}} icon={true} iconClass={"fe fe-search"}/>
                                        </div>
                                        <div className={"form-check d-inline-block ms-5 mb-3"}>
                                            <input className={"form-check-input form-check-med"} id={"users-show"}
                                                   style={{borderWidth: "1px", borderStyle: "solid", borderColor: "var(--color-border-medium)"}}
                                                   type={"checkbox"} checked={showChecked} onChange={(e) => {
                                                       setShowChecked(e.target.checked);
                                            }} />
                                            <label className={"form-check-label text-dark"} htmlFor={"users-show"}>Show selected only</label>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}} id={"user-selector-text"}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {userTextTableHeader}
                                                </thead>
                                                <tbody>
                                                    {userTextRows}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}} id={"user-selector-voice"}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {userVoiceTableHeader}
                                                </thead>
                                                <tbody>
                                                    {userVoiceRows}
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{maxHeight: "400px", overflowY: "auto"}} id={"user-selector-email"}>
                                            <table className={"table table-sm table-white table-hover"}>
                                                <thead className={"sticky-table-head"} style={{top: "0px"}}>
                                                    {userEmailTableHeader}
                                                </thead>
                                                <tbody>
                                                    {userEmailRows}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className={"modal-footer"} style={{justifyContent: "space-between"}}>
                                    <div>
                                    </div>
                                    <div>
                                        <button type={"button"} className={"btn btn-secondary d-none"} id={"cancelUserBtn"}
                                                data-bs-dismiss={"modal"}>Cancel</button>
                                        <button type={"button"} className={"btn btn-primary ms-3"}
                                                onClick={() => {swapModal("cancelUserBtn", "escmodal")}}
                                                id={"userGroupSubmit"}>
                                            Done
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"careconfirmmodal"} data-bs-backdrop={"static"}
                     data-bs-keyboard={"false"} tabIndex={-1} aria-labelledby={"staticCareDeleteSubmitLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticCareDeleteSubmitLabel"}>Confirm Delete</h2>
                                <button type={"button"} className={"btn-close"} id={"careDeleteSubmitClose"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <div className={"modal-body"}>
                                <p>
                                    Are you sure you wish to permanently delete careflow '{careName}' and its corresponding workflows?
                                </p>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelCareDeleteSubmitBtn"}
                                        data-bs-dismiss={"modal"} style={{width: "125px"}}
                                        onClick={() => showModal("caremodal")}>No
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none mx-4"} style={{width: "125px"}}
                                        disabled={true} spinner={true} text={"Deleting"} id={"loadCareDeleteSubmit"}/>
                                <Button text={"Yes"} class={"btn btn-primary mx-4"} id={"careDeleteSubmit"} style={{width: "125px"}}
                                        type={"button"} onClick={() => deleteCareflowSubmit()}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"flowconfirmmodal"} data-bs-backdrop={"static"}
                     data-bs-keyboard={"false"} tabIndex={-1} aria-labelledby={"staticFlowDeleteSubmitLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticFlowDeleteSubmitLabel"}>Confirm Delete</h2>
                                <button type={"button"} className={"btn-close"} id={"flowDeleteSubmitClose"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <div className={"modal-body"}>
                                <p>
                                    Are you sure you wish to permanently delete workflow '{flowName}' and its corresponding escalations?
                                </p>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelFlowDeleteSubmitBtn"}
                                        data-bs-dismiss={"modal"} style={{width: "125px"}}
                                        onClick={() => showModal("flowmodal")}>No
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none mx-4"} style={{width: "125px"}}
                                        disabled={true} spinner={true} text={"Deleting"} id={"loadFlowDeleteSubmit"}/>
                                <Button text={"Yes"} class={"btn btn-primary mx-4"} id={"flowDeleteSubmit"} style={{width: "125px"}}
                                        type={"button"} onClick={() => deleteWorkflowSubmit()}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={"modal fade"} id={"escconfirmmodal"} data-bs-backdrop={"static"}
                     data-bs-keyboard={"false"} tabIndex={-1} aria-labelledby={"staticEscDeleteSubmitLabel"} aria-hidden={"true"}>
                    <div className={"modal-dialog"}>
                        <div className={"modal-content"}>
                            <div className={"modal-header bg-pal"}>
                                <h2 className={"modal-title"} id={"staticEscDeleteSubmitLabel"}>Confirm Delete</h2>
                                <button type={"button"} className={"btn-close"} id={"escDeleteSubmitClose"}
                                        data-bs-dismiss={"modal"} aria-label={"Close"}/>
                            </div>
                            <div className={"modal-body"}>
                                <p>
                                    Are you sure you wish to permanently delete '{escName}' escalation?
                                </p>
                            </div>
                            <div className={"modal-footer"}>
                                <button type={"button"} className={"btn btn-secondary"} id={"cancelEscSubmitBtn"}
                                        data-bs-dismiss={"modal"} style={{width: "125px"}}
                                        onClick={() => showModal("escmodal")}>No
                                </button>
                                <Button type={"button"} class={"btn btn-primary d-none mx-4"} style={{width: "125px"}}
                                        disabled={true} spinner={true} text={"Deleting"} id={"loadEscDeleteSubmit"}/>
                                <Button text={"Yes"} class={"btn btn-primary mx-4"} id={"escDeleteSubmit"} style={{width: "125px"}}
                                        type={"button"} onClick={() => deleteEscalationSubmit()}/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Floating Help Button - Quarter Circle Corner Shape */}
            <button 
                type={"button"} 
                className={"help-corner-button"}
                onClick={() => showModal("helpmodal")}
                title={"Page Help Popup"}
                aria-label={"Open Help"}
            >
                <i className={"fe fe-help-circle help-corner-button-icon"}></i>
            </button>
            <Suspense fallback={"Loading..."}>
                <ToastContainer position={"bottom-right"} theme={"colored"} newestOnTop={true} pauseOnHover={true}
                                autoClose={10000} closeOnClick={true}/>
            </Suspense>
            <div className={"modal fade help-modal-pop"} id={"helpmodal"} data-bs-backdrop={"static"} data-bs-keyboard={"false"}
                 tabIndex={-1} aria-labelledby={"staticHelpBackdropLabel"} aria-hidden={"true"}>
                <div className={"modal-dialog modal-lg"}>
                    <div className={"modal-content"}>
                        <div className={"modal-header bg-pal"}>
                            <h2 className={"modal-title"} id={"staticHelpBackdropLabel"}>Careflow Page Help</h2>
                            <button type={"button"} className={"btn-close"} id={"helpClose"} data-bs-dismiss={"modal"}
                                    aria-label={"Close"}/>
                        </div>
                        <div className={"modal-body"}>
                            <div className={"mb-4"}>
                                <h4 className={"text-primary mb-3"}>
                                    <i className={"fe fe-info me-2"}></i>Getting Started
                                </h4>
                                <p className={"mb-2"}>
                                    The Careflow page allows you to configure how alerts are routed and escalated based on different criteria. 
                                    Careflows define workflows, which contain escalations that determine who gets notified and when.
                                </p>
                            </div>
                            
                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-layers me-2 text-primary"}></i>Careflow Priority Hierarchy
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Event Careflow (Highest Priority):</strong> Applies to specific event types, supersedes all other careflows.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Device Careflow (2nd Priority):</strong> Applies to specific devices, supersedes default, area, and resident careflows.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Resident Careflow (3rd Priority):</strong> Applies to residents in attached resident groups, supersedes default and area careflows.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Area Careflow (4th Priority):</strong> Applies to areas in attached area groups, supersedes default careflows.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Default Careflow (Lowest Priority):</strong> Serves as the final default level when no higher-priority careflow applies.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-plus me-2 text-primary"}></i>Creating Careflows
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click <strong>"New Careflow"</strong> to create a new careflow.
                                    </li>
                                    <li className={"mb-2"}>
                                        Enter a name and optional description for the careflow.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Event Careflows:</strong> Select an event category and event type.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Area/Resident/Device Careflows:</strong> Select the groups or devices this careflow applies to.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any careflow to modify its settings.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-clock me-2 text-primary"}></i>Workflows
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Each careflow can have multiple workflows that define time windows.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Workflow"</strong> to add a new workflow to a careflow.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Time Window:</strong> Set the start and end times for when this workflow is active (24-hour format).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Muted:</strong> (Non-default careflows only) Mute alerts during this workflow's time window.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Important:</strong> Workflows should cover the entire day (24 hours) to ensure all alerts are handled.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click the edit icon on any workflow to modify its settings.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-activity me-2 text-primary"}></i>Escalations
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Each workflow can have multiple escalations that define notification periods.
                                    </li>
                                    <li className={"mb-2"}>
                                        Click <strong>"Escalation"</strong> to add a new escalation to a workflow.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Period:</strong> Set the time period (in minutes) when this escalation is active (0 to max alert timeout).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Important:</strong> Escalations should cover the full period from 0 to the max alert timeout with no gaps.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Output Types:</strong> Enable Mobile, Pager, Text, Email, Voice, or Offsite Monitoring notifications.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Repeat Interval:</strong> Set how often to repeat notifications (0 = send once only).
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Attach Users/Groups:</strong> Select which users or user groups receive notifications for each output type.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use "Show Details" to view all configured outputs for an escalation.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-alert-triangle me-2 text-primary"}></i>Warning Indicators
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        <strong>Red Border:</strong> Indicates missing workflows or incomplete escalation coverage.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Yellow Border:</strong> Indicates missing entity assignments or incomplete day coverage.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Overlap Warning:</strong> Escalation periods that overlap with other escalations in the same workflow.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>No Workflows:</strong> Careflows without workflows will not process any alerts.
                                    </li>
                                    <li className={"mb-2"}>
                                        <strong>Incomplete Coverage:</strong> Workflows that don't cover the full 24-hour day may miss alerts.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-4"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-trash-2 me-2 text-primary"}></i>Deleting Careflows
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Click the edit icon on a careflow, then click <strong>"Delete"</strong> to remove it.
                                    </li>
                                    <li className={"mb-2"}>
                                        Deleting a careflow will also delete all associated workflows and escalations.
                                    </li>
                                    <li className={"mb-2"}>
                                        This action cannot be undone, so be certain before confirming deletion.
                                    </li>
                                </ul>
                            </div>

                            <div className={"mb-3"}>
                                <h5 className={"fw-bold mb-2"}>
                                    <i className={"fe fe-settings me-2 text-primary"}></i>Additional Tips
                                </h5>
                                <ul className={"list-unstyled ms-4"}>
                                    <li className={"mb-2"}>
                                        Always ensure workflows cover the entire 24-hour day to avoid missing alerts.
                                    </li>
                                    <li className={"mb-2"}>
                                        Escalations should cover the full period from 0 to max alert timeout with no gaps.
                                    </li>
                                    <li className={"mb-2"}>
                                        Avoid overlapping escalation periods within the same workflow when possible.
                                    </li>
                                    <li className={"mb-2"}>
                                        Test your careflow configuration to ensure alerts are routed correctly.
                                    </li>
                                    <li className={"mb-2"}>
                                        Default careflow is required and serves as the fallback for all alerts.
                                    </li>
                                    <li className={"mb-2"}>
                                        Use the search functionality when selecting groups, devices, or users to quickly find items.
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className={"modal-footer"}>
                            <button type={"button"} className={"btn btn-secondary"} data-bs-dismiss={"modal"}>Close</button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Careflow;
